import React, { Component } from "react";
import CreatableSelect from 'react-select/creatable';

import { TabContent, TabPane, Row, Col, Label } from 'reactstrap';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
// import { OrderContext } from "../kitchen/orderContext";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from 'reactstrap';
import {Card} from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import swal from 'sweetalert';
import { Link, useHistory } from "react-router-dom";
import ReactToPrint from 'react-to-print';
import { var_api } from "../constant";
import SearchableDropdown from "../creditCustomers/search";
import ReactDOMServer from 'react-dom/server';
import { data } from "jquery";
import Select from 'react-select';
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { Display } from "react-bootstrap-icons";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import basic from '../../images/sb-images/basci.jpeg';
import delux from '../../images/sb-images/delux.jpeg';
import pamper from '../../images/sb-images/pampering.jpeg';
import skin1 from '../../images/sb-images/skin1.jpeg';
import skin2 from '../../images/sb-images/skin2.jpeg';
import skin3 from '../../images/sb-images/skin3.jpeg';
import room1 from '../../images/sb-images/room1.jpeg';
import room2 from '../../images/sb-images/room2.jpeg';
import chair1 from '../../images/sb-images/chair1.webp';
import chair2 from '../../images/sb-images/chair2.webp';
import chair3 from '../../images/sb-images/chair3.webp';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown, Table} from 'react-bootstrap';
import sage from '../../images/splash/sage.jpeg';
import CardGroup from 'react-bootstrap/CardGroup';
import sign from '../../images/sb-images/sage sig.webp';
import detoxi from '../../images/sb-images/detoxi.webp';
import hydra from '../../images/sb-images/hydrascalp.webp';
import clari from '../../images/sb-images/clari.webp';
import scla from '../../images/sb-images/scla.webp';
import fruit from '../../images/sb-images/fruit.webp';
import puri from '../../images/sb-images/puri.webp';
import rooms1 from "../../images/sb-images/r1.jpeg";
import rooms2 from "../../images/sb-images/r2.jpeg";
import seats1 from "../../images/sb-images/s1.jpeg";
import seats2 from "../../images/sb-images/s2.jpeg";
import {   NavItem, NavLink } from 'reactstrap';
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import { config } from "@fortawesome/fontawesome-svg-core";

toast.configure()


  class SbHOme extends React.Component {


    constructor(props) {
      
      super(props);
      this.routeserviceChange = this.routeserviceChange.bind(this);
      this.routeRoomSeat=this.routeRoomSeat.bind(this);
      this.routeEmployees=this.routeEmployees.bind(this);
      this.routeAvailableDayTime = this.routeAvailableDayTime.bind(this);
      this.routeTaxMaster = this.routeTaxMaster.bind(this);
      this.routeReminderMaster = this.routeReminderMaster.bind(this)
      this.routePhotoGalleryMaster = this.routePhotoGalleryMaster.bind(this);
      this.routePackageMaster = this.routePackageMaster.bind(this);
      this.routeReports = this.routeReports.bind(this);  
      this.routeShopSettings = this.routeShopSettings.bind(this);  
      this.routeCustomerDetails=this.routeCustomerDetails.bind(this);
      this.routeRoomSeatStatus =  this.routeRoomSeatStatus.bind(this);
      this.routeCancellation =  this.routeCancellation.bind(this);
      this.routeEmployeeServices =  this.routeEmployeeServices.bind(this);
      this.routeEmployeeSalary =  this.routeEmployeeSalary.bind(this);
      this.routeSupplier = this.routeSupplier.bind(this);
      this.routeUom = this.routeUom.bind(this);
      this.toggle = this.toggle.bind(this);
      this.toggleNav = this.toggleNav.bind(this);
      this.toggleChange = this.toggleChange.bind(this);
      this.handleOnclick = this.handleOnclick.bind(this);
      this.routeReport = this.routeReport.bind(this);
      this.routeContract = this.routeContract.bind(this);
      this.routeGroupOrders =  this.routeGroupOrders.bind(this);
      this.routeEmployee = this.routeEmployee.bind(this);
      this.routeRawMaterial = this.routeRawMaterial.bind(this);
      this.routeRoomSeatStatusmaster = this.routeRoomSeatStatusmaster.bind(this);
      this.routeOutstandingpayment = this.routeOutstandingpayment.bind(this);
      this.routeItemSummary = this.routeItemSummary.bind(this);
      this.routeOrderhistory= this.routeOrderhistory.bind(this);


      
      this.routeSbReports =  this.routeSbReports.bind(this);
      this.routeAttendance=this.routeAttendance.bind(this);
      this.toggleTab = this.toggleTab.bind(this);


      this.handleModLogout = this.handleModLogout.bind(this);
      this.handleCloseConfirmation = this.handleCloseConfirmation.bind(this);
      this.routeSettlements = this.routeSettlements.bind(this);
      this.routeParcelStatus = this.routeParcelStatus.bind(this);
      this.routenNewSettlements = this.routenNewSettlements.bind(this);
      this.handleSwitchToggle = this.handleSwitchToggle.bind(this);
      this.handleInstandFoodChange = this.handleInstandFoodChange.bind(this);
      this.handleInstandQuantityChange = this.handleInstandQuantityChange.bind(this);
      this.handleInstandPriceChange =  this.handleInstandPriceChange.bind(this);
      this.routeSubKitchenmaster =  this.routeSubKitchenmaster.bind(this);
      this.routeRole = this.routeRole.bind(this);
      this.handleCloseCanvas = this.handleCloseCanvas.bind(this);
      this.handleShowCanvas = this.handleShowCanvas.bind(this);
      this.handleCloseServices = this.handleCloseServices.bind(this);
      this.handleShowServices = this.handleShowServices.bind(this);

      this.handleNameChange = this.handleNameChange.bind(this);
      this.handleDobChange = this.handleDobChange.bind(this);
      this.handleCheckboxDobChange = this.handleCheckboxDobChange.bind(this);
      this.handleMobileChange = this.handleMobileChange.bind(this);
      this.handleMobileTextChange = this.handleMobileTextChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleCheckboxChangeService = this.handleCheckboxChangeService.bind(this);
      this.handleDateChange = this.handleDateChange.bind(this);
      this.handleCancelAddOrder = this.handleCancelAddOrder.bind(this);

      this.userRole = localStorage.getItem('role');
      
      this.state = {
        dropdownOpen: false
      };
      this.state = {
        shadropdownOpen: false
      };
      const shopNameFromLocalStorage = localStorage.getItem('shop_name');
      this.state = {
        activeTab: '1'
      };
      this.state = {
        selectedCategory: null
      };
      this.state = {
        hoveredSlot: null,
      };
      // Get today's date
      const today = new Date();

     // Format the date as dd-mm-yyyy
      const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
       // Format the date as dd-mm-yyyy
       const formattedInputDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
      this.state = {// Default selected seat ID (change as necessary)
        selectedBooking: null, // Store selected booking for the modal
        isModalOpen: false,
        timeList: [],
        typeBooking:[],
        isChecked:true,
        activeTab: 2,
        selectedList: 'Breakfast',
        customers:[], // Set the default selected list to 'Breakfast'
        orderNo: 100,
        showTable: false,
        shopName: '',
        users:[],
        categories: [],
        foods: [],
        cartItems: [],
        orders: [],
        mobileInput:[],
        searchQuery:'',
        checkedCategories:false,
        loading:false,
        selectedCreditCustomer: null,
        creditName:'',
        creditMobile:'',
        selectedData: '',
        firstCategoryId:0,
        isPrinted:false,
        ItemCodeOptions:[],
        selectedItemCode:null,
        show:false,
        orderHistoryItems:[],
        selectedOrderLabel:  { value: '1', label: 'Inprogress'},
        selectedPayMode: null,
        editpaymode:null,
        updateRemark:" ",
        labelCodeOptions: [
          { value: '0', label: 'Upcoming'},
          { value: '1', label: 'Inprogress'},
          { value: '2', label: 'Closed'},
          { value: '3', label: 'All' },
        ], 
        payModeOptions: [
          
      ], 
      payModes:[],
        startDate: formattedDate,
        endDate: formattedDate,
        isOpenSelectDate:false,
        orderSummary:{},
        isOpenOrderSummary:false,
        order_no:null,
        isLogin:false,
        iscredit:false,
        orderLoading: false,
        amountDetail:{},
        isNormalModal: false,
        isNormalCreditModal:false,
        isCreditModal:false,
        isParcelChecked: false,
        orderResponse:{},
        isOrderConfirmation:false,
        imageStatus: false,
        isPayModeEdit:false,
        editPaymodeOrder:null,
        isPayModeEditLoading:false, 
        selectedAmounts: [],
        isAmountSetByCardClick: false, // Initially set to false 
        enteredPaymodes:null,
        isOpenAddInstant: false,
        instantFoodName:null,
        instantQuantity:null,
        instantPrice:null,
        editSelectedAmounts:[],
        isMastersMenuOpen: false,
        isRoom:true,
        showCanvas: false,
        showService: false,
        timeSlots : ['10:00 AM', '11:00 AM', '12:00 PM', '01:00 PM', '02:00 PM'],
        rooms : [],
        seats : [
          { id: 1, name: 'seat 1', description: 'Description for seat 1', image: seats1 },
          { id: 2, name: 'seat 2', description: 'Description for seat 2', image: seats2 },
          { id: 3, name: 'seat 3', description: 'Description for seat 3', image: seats1 }
        ],
          activeTab: "1", // Initialize with your desired default value
          serviceCart:[],
          selectedRoomId: null,
          selectedRoomName:null,
          selectedTime:null,
          todayDateInput: formattedInputDate,
          customerName: '',
          customerMobile: '',
          checkedItems: {},
          selectedSeatId:null,
          selectedSeatName:null,
          viewService:null,
          selectedDate: new Date().toISOString().split('T')[0], // Initialize with the current date in YYYY-MM-DD format
          servicesHistory: [],
          servicesSummaryHistory: {},
          selectedOption: '1',
          allServicesHistory: [], // To store all fetched data
          empChecking:null,
          from_time: '',
          to_time: '',
          beautician: null,
          validationError: '',
          isFree: true,
          chekcingServices: [],
          beauticians: [],
          selectedCategory: null,
          isLoader:false,
          isHistoryLoader:false,
          isOpenOrderEdit:false,
          updatedOrder:null,
          isDelete: false,
          deletedOrder: null,
          deletedBooking:null,
          remarks: " ",
          ExistingOrder:null,
          additionalChecked: {}, // State to track the "Additional" checkbox
          mobileOptions:[],
          isDobChecked: false,
          dob: '', // Initial state for date of birth
          imageStatus: localStorage.getItem('image_status') === '1',
          additionalCheckedUpdate: false,
          additionalCostUpdate: 0,
          additionalDurationUpdate: 0,
          summaryCounts: { total: 0, upcoming: 0, inProgress: 0, closed: 0 },
          token: localStorage.getItem('token'),
          gender: '', // Set default gender to Female
          email: '',
          selectedGender: 'All',
          admin_Email: localStorage.getItem('empEmailId')
      };
    }
    handleCategoryClick = idx => {
      this.setState({ selectedCategory: idx });
    };
    componentDidMount() {
      if (!this.state.token) {
        this.props.history.push('/signin');
      }
      this.getallservice();
      this.fetchRoomData(this.state.todayDateInput);
      this.fetchSeatData(this.state.todayDateInput);
      const currentDate = new Date().toISOString().split('T')[0];
      // this.handleOptionChange(this.state.labelCodeOptions.find((option) => option.value === '1'));
      this.setState({ selectedDate: currentDate }, () => {
        this.fetchData(this.state.selectedDate);
        this.fetchSummaryData();
        this.getTimeInterval(this.state.selectedDate);
        // this.getTypeBooking(this.state.selectedDate);
      });
      // this.fetchRoomChecking();
      this.fetchSeatChecking();
      this.fetchBeauticians();
      this.fetchTaxMaster();
      const savedCart = localStorage.getItem('serviceCart');
      if (savedCart) {
        this.setState({ serviceCart: JSON.parse(savedCart) });
      }
     
    }

    componentDidUpdate(prevProps, prevState) {
      // Effect to update localStorage when imageStatus changes
      if (prevState.imageStatus !== this.state.imageStatus) {
          localStorage.setItem('image_status', this.state.imageStatus ? '1' : '0');
      }

      // Your other componentDidUpdate logic
      // ...
  }

   
  //show the shop name in center
  getallservice() {
    this.setState({ isLoader: true});
    const token = localStorage.getItem('token'); // Retrieve the token from localStorage
    axios.get(`${var_api}/api/cate/subfood`, {
        headers: {
            'Authorization': `${token}` // Include the token in the Authorization header
        }
    })
    .then((response) => {
        const data = response.data;
        this.setState({ categories: data.categories });
        console.log("cat", data.categories);
        console.log(data);
        this.setState({ isLoader: false});
    })
    .catch((error) => {
        console.error('Error fetching service name:', error);
        this.setState({ isLoader: false});
        if (error.response && error.response.status === 401) {
          this.props.history.push('/signin');
      }
        // Handle the error if needed
    });
}

        //Fetch the order history
        fetchAllOrdersHistory = async (order_label) => {
          const shopId = localStorage.getItem('shopId')
          this.setState({orderLoading: true});
          try {
           const response = await axios.get(`${var_api}/api/food/normaldate/related-data/${shopId}/${order_label}/${this.state.startDate}/${this.state.endDate}` );
           const data = response.data;
           if (data.length > 0) {
             // If there are categories in the response, set the ID of the first category in the state
             this.setState({ orderHistoryItems: data });
             this.setState({orderLoading: false});
             // this.handleListClick(this.state.firstCategoryId)
           } else {
             // Handle the case where there are no categories
             console.log('No categories found.');
             this.setState({ orderHistoryItems: [] });
             this.setState({orderLoading: false});
           }
         }catch (error) {
           console.log('Error fetching data:', error);
           
           }
         };

    //Fetch the order history
    fetchAllOrdersSummary = async (order_label) => {
      const shopId = localStorage.getItem('shopId')
      try {
       const response = await axios.get(`${var_api}/api/food/summary/related-data/${shopId}/${order_label}/${this.state.startDate}/${this.state.endDate}` );
       const data = response.data;
       console.log("oooo", response.data);
       
         // If there are categories in the response, set the ID of the first category in the state
         this.setState({ orderSummary: data });
         console.log("oooo", response);
       
     }catch (error) {
       console.log('Error fetching data:', error);
       this.setState({ orderSummary: [] });
       }
     };


     //list the pay modes
     handleListPayModes =async() => {
      try {
        const response = await axios.get(`${var_api}/api/pay-mode/get-active-mode` );
        const data = response.data
        const options = data.map(modes => ({
          value: modes.pay_mode_name,
          label:  modes.pay_mode_name
        }));
        this.setState({payModeOptions: options, payModes:data})
        const newSelectedAmounts = Array(this.state.payModes.length).fill(0);
        this.setState({ selectedAmounts: newSelectedAmounts});
       console.log("payyyyy",data);
      }catch (error) {
        console.log('Error fetching data:', error);
        
        }
      }


   
    handleListClick =async() => {
      const id = localStorage.getItem('shopId')
      this.setState({ loading : true });
      try {
        const response = await axios.get(`${var_api}/api/categories/cate/subfood/${id}` );
        const data = response.data
        this.setState({ foods: data.categories});
        this.setState({ loading : false });
        // this.fetchOrderHistory();
      }catch (error) {
        console.log('Error fetching data:', error);
        
        }
//       this.setState({ loading : true });
// const shopName = localStorage.getItem('shopName');
//       console.log("shop category:",shopName)
//       const colRef = collection(db, `shops/${shopName}/categories/${id}/foodMaster`);
//       const q = query(colRef);
//         const unsub = onSnapshot(q, (snapshot) => {
//           const foodNames = snapshot.docs.map((doc) => ({ id: doc.id, data: doc.data() }));
//           this.setState({ foods: foodNames, defaultCategoryId: id });
//           this.setState({ loading : false });
//         });
      };


  
    toggle(tab) {
     
      const { activeTab } = this.state;
      // this.fetchCategories();
  
      if (activeTab === tab) {
    
        // Close the active tab if it's clicked again
        this.setState({ activeTab: null });
      } else {
      
        this.setState({ activeTab: tab });
        
      }
    }

    // routeChange() {
    //   const { shopName } = this.state;
    //   let path = `/cate/${encodeURIComponent(shopName)}`;
    //   this.props.history.push(path);
    // }

    routeserviceChange() {
      let path = `/service-categories`;
      this.props.history.push(path);
    }

    routeRoomSeat() {
      let path = `/roomseat-master`;
      this.props.history.push(path);
    }


    routeRole() {
      let path = `/role-master`;
      this.props.history.push(path);
    }

    routeAttendance() {
      if (this.userRole === 'Admin' || this.userRole === 'Manager') {
        let path = `/sb-attendance`;
        this.props.history.push(path);
      } else {
        // Show popup for unauthorized users
        // window.alert('Only admins and managers can view the Employee Log.');
        swal({
          title: 'Access Denied!',
          text: 'Only admins and managers can view the Employee Log.',
          icon: 'warning',
          button: 'OK',
          confirmButtonColor: 'rgba(103,120,95,1)',
        });
      }
    }

    routeEmployees() {
      let path = `/service-employees`;
      this.props.history.push(path);
    }

    routeAvailableDayTime() {
      let path = `/availabledaytime-master`;
      this.props.history.push(path);
    }

    routeTaxMaster() {
      let path = `/tax-master`;
      this.props.history.push(path);
    }

    routeReminderMaster() {
      let path = `/reminder-master`;
      this.props.history.push(path);
    }

    routePhotoGalleryMaster() {
      let path = `/photo-gallery-master`;
      this.props.history.push(path);
    }

    routePackageMaster() {
      let path = `/package-master`;
      this.props.history.push(path);
    }

    routeReports() {
      let path = `/reports`;
      this.props.history.push(path);
    }

    routeShopSettings() {
      let path = `/shop-settings`;
      this.props.history.push(path);
    }

    routeCustomerDetails() {
      let path = `/customer-details`;
      this.props.history.push(path);
    }

    routeRoomSeatStatus() {
      let path = `/roomseat-status`;
      this.props.history.push(path);
    }

    routeCancellation() {
      let path = `/cancellation-status`;
      this.props.history.push(path);
    }

    routeEmployeeServices() {
      let path = `/employee-services`;
      this.props.history.push(path);
    }

    routeEmployeeSalary() {
      let path = `/employee-salary`;
      this.props.history.push(path);
    }

    routeContract() {
      let path = `/contract`;
      this.props.history.push(path);
    }

    routeReport() {
      let path = `/report`;
      this.props.history.push(path);
    }

    routeUom() {
      let path = `/uom-master`;
      this.props.history.push(path);
    }

    routeGroupOrders() {
      let path = `/groupOrders`;
      this.props.history.push(path);
    }


    routeSupplier() {
      let path = `/supplier-master`;
      this.props.history.push(path);
    }

    routeEmployee() {
      let path = `/employee-master`;
      this.props.history.push(path);
    }

    routeRawMaterial() {
      let path = `/RawMaterial-master`;
      this.props.history.push(path);
    }

    routeRoomSeatStatusmaster() {
      let path = `/table-master`;
      this.props.history.push(path);
    }

    routeSubKitchenmaster() {
      let path = `/sub-kitchen-master`;
      this.props.history.push(path);
    }


    routeSbReports() {
      let path =`/sb-report`;
      this.props.history.push(path);
    }

     routeOutstandingpayment() {
        let path = `/Outstandingpayment`;
        this.props.history.push(path);
    }

    handleCloseCanvas() {
      this.setState({ showCanvas: false });
    }
  
    handleShowCanvas() {
      this.setState({ showCanvas: true });
    }

    handleCloseServices() {
      this.setState({ showService: false });
    }
  
    handleShowServices() {
      this.setState({ showService: true });
    }

    toggleTab(tab) {
      if (this.state.activeTab !== tab) {
        this.setState({ activeTab: tab });
      }
    }


    // handleMovetoSeat=()=>{
    //   const tabNo = this.state.activeTab === "1" ? "2" : "1";
    //   this.setState({isOpenAddInstant: true, activeTab: tabNo})
    // }
  

    handleMovetoSeat = () => {
      const tabNo = this.state.activeTab === "1" ? "2" : "1";
      
      // Reset necessary fields for each service in the cart
      const updatedServiceCart = this.state.serviceCart.map(service => ({
        ...service,
        from_time: null,
        to_time: null,
        additionalPrice: null,
        additionalDuration: null,
        employee_name: null,
        employee_id: null,
        room_id: null,
        room_name: null,
        seat_id: null,
        seat_name: null,
        // You can omit `checkedItems` here as it is being handled separately
      }));
    
      // Reset the checkedItems to null or false
      const updatedCheckedItems = Object.keys(this.state.checkedItems).reduce((acc, key) => {
        acc[key] = false; // Reset each checked item to false
        return acc;
      }, {});
    
      // Update the state with the modified serviceCart and checkedItems, and switch tabs
      this.setState({ 
        isOpenAddInstant: false, 
        activeTab: tabNo,
        serviceCart: updatedServiceCart, // Set the updated cart with nullified values
        checkedItems: updatedCheckedItems ,// Reset checkedItems as well
        selectedRoomName: null, // Reset selectedRoomName
        selectedSeatName: null, // Reset selectedSeatName
    
      });
      console.log("uci", updatedServiceCart, this.calculateSubtotal());
    };
    
    
    routeItemSummary() {
      let path = `/item-summary`;
      this.props.history.push(path);
  }

  routeOrderhistory() {
    let path = `/order-history`;
    this.props.history.push(path);
}

routeSettlements() {
  let path = `/expense-log`;
  this.props.history.push(path);
}

routenNewSettlements() {
  let path = `/new-settlement`;
  this.props.history.push(path);
}

routeParcelStatus() {
  let path = `/parcel-kitchen`;
  this.props.history.push(path);
}


    toggleNav() {
      
      this.setState(prevState => ({
        dropdownOpen: !prevState.dropdownOpen

      }));
     
    }

      toggleChange() {
        this.setState(prevState => ({
          shadropdownOpen: !prevState.shadropdownOpen
        }));

    }


    toggleMastersMenu = () => {
      this.setState(prevState => ({
        isMastersMenuOpen: !prevState.isMastersMenuOpen,
        dropdownOpen: !prevState.dropdownOpen
      }));
    }
  

    // handleAddToCart = (foodItem) => {
    //   // Add logic to handle adding the selected food item to the cart
    //   // For demonstration, let's just redirect to the cart page
  
    //   // Redirect to the cart page
    //   this.props.history.push({
    //     pathname: '/cart',
    //     state: { foodItems: [foodItem] },
    //   });
    // };


    
    handleNameSelection = (name) => {
      if(name.shop_type === 2){
        this.setState({
          shopName: name.shop_name,
        });
        localStorage.removeItem('shopName')
        const shopName=localStorage.setItem('shopName',name.shop_name)
        localStorage.setItem('shopId',name.id)
        // this.fetchCategories();
        this.handleListClick();
        this.fetchAllOrdersHistory(this.state.selectedOrderLabel.value);
        this.fetchAllOrdersSummary(this.state.selectedOrderLabel.value);
        this.getExitingOrderNo();
        this.setState({foods:[]})
        this.setState({orders:[]})
        console.log("type",name.shop_type)
        localStorage.setItem('shopType',name.shop_type);

      }else{
        localStorage.removeItem('shopName')
        const shopName=localStorage.setItem('shopName',name.shop_name)
        localStorage.setItem('shopId',name.id)
        this.props.history.push('/home');
        console.log("type",name.shop_type)
        localStorage.setItem('shopType',name.shop_type);
        
      }
     
    };

    

    handleOnclick(){
      this.setState({show:true})
      
    }

   


    handleCloseConfirmation(){
      this.setState({show: false})
    }


     //function for logout
  handleModLogout(){
   const logout= localStorage.removeItem('token');
   const place = localStorage.getItem('token');
  //  const shop= localStorage.removeItem('shopId');
  //     const place = localStorage.getItem('userId');
  //     console.log("id",place)
      if(place==null){
        this.props.history.push('/signin')
      }
  //     localStorage.removeItem('shopName');
  //     localStorage.removeItem('shopType');

      }
    

    //fetch all the item code
    fetchItemCode= async()=> {
      const shopId = localStorage.getItem('shopId')
        try {
          const response = await axios.get(`${var_api}/api/foodMaster/api/allFood/${shopId}`);
          const data = response.data.result;
    
          // Transform the data from the API into the format expected by react-select
          const formattedOptions = data.map(item => ({
            label: item.item_code, // Change this to the actual property name from your API response
          }));
    
          this.setState({ItemCodeOptions:formattedOptions});
        } catch (error) {
          console.log('Error fetching data:', error);
          
        }
}

   //fetch the customer balance
   fetchCustomerBalance= async(id)=> {
    const shopId = localStorage.getItem('shopId')
      try {
        const response = await axios.get(`${var_api}/api/payment/balancedata/${id}/${shopId}`);
        const data = response.data;
       console.log("de",data)
        this.setState({amountDetail:data});
      } catch (error) {
        console.log('Error fetching data:', error);
        
      }
}



  //set the selected item code
   handleCodeSelectChange = (data) => {
    this.fetchItemCode();
 
    this.setState({selectedItemCode:data}, () => {
      console.log('selected item code:', this.state.selectedItemCode);
    });
   }


    handleSearchInput = (e) => {
     this.setState({
      searchQuery : e.target.value,
     });
    };


    //fetch the item details filter by item code
    handleAddByItemCode = async () => {
      const { selectedItemCode } = this.state
      if(selectedItemCode && selectedItemCode.label){
        const item_code = selectedItemCode.label
      const shopId = localStorage.getItem('shopId')
      try {
        const response = await axios.get(`${var_api}/api/foodMaster/api/filterItem/${shopId}/${item_code}`);
        const data = response.data.result;

        const food = data[0];
       // Add the selected food to the cart
        this.addToCart(food);
        console.log("selected food details",food)
  
       
      } catch (error) {
        console.log('Error fetching data:', error);
        
      }
        
      }else{
        Swal.fire({
          text:"Select Item Code Before Add",
          confirmButtonColor: '#007500',
        })
      }
      
    }


    incrementQuantity = (itemId) => {
      const { cartItems } = this.state;
      console.log("itemid", itemId)
      const updatedCartItems = cartItems.map((item) => {
        if (item.id === itemId) {
          console.log("q",item.quantity, parseInt(item.quantity)+1)
          return { ...item, quantity: parseInt(item.quantity) + 1 };
        }
        return item;
      });
      this.setState({ cartItems: updatedCartItems });
    };
    
    decrementQuantity = (itemId) => {
      const { cartItems } = this.state;
      const updatedCartItems = cartItems.map((item) => {
        if (item.id === itemId && item.quantity > 0) {
          return { ...item, quantity: item.quantity - 1 };
        }
        return item;
      });
      this.setState({ cartItems: updatedCartItems });
    };
    


    addToCart = () => {
      const { isNormalCreditModal, isNormalModal } = this.state;
  // const existingItemIndex = cartItems.findIndex((item) => item.food.id === food.id);

  // if (existingItemIndex !== -1) {
  //   const updatedCartItems = [...cartItems];
  //   updatedCartItems[existingItemIndex].quantity += 1;
    this.setState({ isNormalCreditModal: true, isNormalModal:false });
  // } else {
  //   const cartItemId = Date.now();
  //   this.setState((prevState) => ({
  //     cartItems: [...prevState.cartItems, {  id: cartItemId,food: food, quantity: 1 }],
  //   }));
  // }
  // console.log("cc",cartItems);
    };

    removeFromCart = (cartItemId) => {
      const { cartItems } = this.state;
      const updatedCartItems = cartItems.filter((item) => item.id !== cartItemId);
      this.setState({ cartItems: updatedCartItems });
    };

    fetchCreditUser = async () => {
      const shopId = localStorage.getItem('shopId');
     try {
      const response = await axios.get(`${var_api}/api/credituser/data/${shopId}` );
      const data = response.data;
      this.setState({ mobileInput: data });
    }catch (error) {
      console.log('Error fetching data:', error);
      this.setState({ mobileInput: [] });
      }
    };


    //find the big order number
getExitingOrderNo() {
  const shop_id = localStorage.getItem('shopId');
  axios.get(`${var_api}/api/food/bigorderno/${shop_id}`)
    .then((response) => {
      const data = response.data.results;
      console.log("i",data)
      this.setState({ order_no:data[0] });

    })
    .catch((error) => {
      console.error('Error fetching order no:', error);
      // Handle the error if needed
    });
}


clearSelectedValue = () => {
  this.setState({ selectedData: ""}); // Clear the selected value
};


    generateCreditOrder = async () => {
      const { cartItems, order_no, isParcelChecked } = this.state;

  
      //check cart is empty
      if(cartItems.length === 0){
        Swal.fire({
          icon:"error",
          title:"Oops...",
          text:"Your cart is empty. Please add items to your cart before placing an order.",
          confirmButtonColor:"#007500"
        })
      }
      else{
        if( this.state.selectedData.value && this.state.selectedData.label && this.state.selectedData.iden){
          

          const user_balance = this.state.amountDetail.balance;
          const maxLimit = this.state.selectedData.maxCredit;
          const itemTotal = this.state.cartItems.reduce((accumulator, cartItem) => {
            return accumulator + cartItem.quantity * cartItem.food.price;
          }, 0);
          const totalAmount = user_balance + itemTotal;
          console.log("uuu",user_balance,maxLimit,itemTotal,totalAmount)
        if(maxLimit>=totalAmount){
          this.setState({iscredit:true});
        const shopName = localStorage.getItem('shopName');
      // console.log("shop category:",shopName)
      // const orderRef = collection(db, `shops/${shopName}/orders`);
    
      const orderItems = this.state.cartItems.map((cartItem) => {
        return {
          food_id:cartItem.food.id,
          food_name: cartItem.food.food_name,
          quantity: cartItem.quantity,
          unit_price: cartItem.food.price,
          item_code: cartItem.food.item_code,
          category_code:cartItem.food.category_code,
          // Add more properties as needed
        };
      });

      const total = this.state.cartItems.reduce((accumulator, cartItem) => {
        return accumulator + cartItem.quantity * cartItem.food.price;
      }, 0);

      const totalWithServiceCharge = total + 0; // Add a service charge of 5 to the total

console.log('Total with Service Charge:', totalWithServiceCharge);
    
      // const totalItems = this.state.cartItems.reduce((accumulator, cartItem) => {
      //   return accumulator + cartItem.quantity;
      // }, 0);

      const totalItems = this.state.cartItems.length;
    
      try {
        // const timestamp = serverTimestamp();
        // const querySnapshot = await getDocs(orderRef);
        // const orderNumber = querySnapshot.size + 1;
        const currDate = new Date();
        const dd = String(currDate.getDate()).padStart(2, '0');
        const mm = String(currDate.getMonth() + 1).padStart(2, '0'); // January is 0!
        const yyyy = currDate.getFullYear();
        
        const formattedDate = `${dd}-${mm}-${yyyy}`;
        const currTime = new Date().toLocaleTimeString();
        let maxOrderNo = 0;
        // if (order_no > maxOrderNo) {
        //   console.log("orderno",order_no)
        //    maxOrderNo = order_no.max_order_no;
        //   }
          // console.log("m",order_no)
          maxOrderNo = order_no.max_order_no + 1
          // console.log("m",maxOrderNo)

          var remark = document.querySelector('#remark') ? document.querySelector('#remark').value : "-";


    //     const customerName = document.querySelector('#name').value;
    //     const customerPhone = document.querySelector('#mobile').value;


    //     // Validate name (only strings)
    // if (!/^[A-Za-z\s]+$/.test(customerName)) {
    //   alert('Invalid name. Please enter a valid name.');
    //   return;
    // }

    // // Validate mobile number (only 10 digits)
    // if (!/^\d{10}$/.test(customerPhone)) {
    //   alert('Invalid mobile number. Please enter a 10-digit mobile number.');
    //   return;
    // }
// debugger;
console.log("name and phone:",this.state.selectedData.label,this.state.selectedData.value)
const userID = localStorage.getItem('userId');
const shopiD = localStorage.getItem('shopId');
const empID = localStorage.getItem("admin_employee")
const userEmail = localStorage.getItem("emailId");
   // const selectedCreditCustomer = JSON.parse( document.querySelector('#selectedCreditCustomer').value);
       

        // Prepare the data to be sent to the Node.js API
        const orderData = {
          admin_id: parseInt(userID),
          admin_email: userEmail,
          creditUser_id:this.state.selectedData.iden,
          shop_name:shopName,
          shop_id:parseInt(shopiD),
          cust_name: this.state.selectedData.label,
          phone_no: this.state.selectedData.value,
          total_items:totalItems,
          order_no:maxOrderNo,
          total: totalWithServiceCharge,
          order_type:0,
          table_no:0,
          paid_status: 0,
          attender_name: "-",
          captain:"Admin",
          parcel_status:0,
          print_status:0,
          order_label:1,
          items: orderItems,
          ordered_at:formattedDate,
          ordered_time:currTime,
          is_group_location_order:0,
          group_location_order_id:0,
          pay_mode: "CREDIT ORDER",
          remarks:remark,
          is_parcel: isParcelChecked ? 1 : 0,
          user_id:parseInt(userID),
          emp_id:parseInt(empID),
          kitchen_parcel_status:0
        };

         // Send the order data to the Node.js API using axios
    const response = await axios.post(`${var_api}/api/creditorder/api/post`, orderData);
    if (response.status === 200) {

      console.log("customer id:",response.data.idCust)
      const customerID = response.data.idCust;
      const creditUserId =  response.data.creditId;
      const traData = response.data.insertedTransItesIds;
      const paymodesArray = [
        {
          order_id:customerID, 
          shop_id:parseInt(shopiD), 
          id:10, 
          amount:total,
          pay_mode_name:"CREDIT ORDER",
          ordered_at:formattedDate
        }
      ]

      try {
        const response = await axios.post(`${var_api}/api/order-paymode/post`, paymodesArray);
        console.log(response.data); // Log response from server
        console.log( "Succes", response.data.message );
        const entered_Paymodes = response.data.results;
        const enteredPaymodesString = entered_Paymodes.map(paymode => paymode.pay_mode_name).join(', ');
        this.setState({enteredPaymodes: enteredPaymodesString});
      } catch (error) {
        console.error('Error posting pay modes:', error);
      }

      document.querySelector('#remark').value = '';
      this.setState({ selectedPayMode: null});
      this.setState({orderResponse:response.data})
     
      console.log("credit user ids",creditUserId,traData);


      // const creditorderItems = this.state.cartItems.map((cartItem,index) => {
      //   const tradata = response.data.insertedTransItesIds[index]; 
      //   return {
      //     food_name: cartItem.food.food_name,
      //     quantity: cartItem.quantity,
      //     unit_price: cartItem.food.price,
      //     item_code: cartItem.food.item_code,
      //     category_code:cartItem.food.category_code,
      //     trans_id: tradata,
      //     // Add more properties as needed
      //   };
      // });
      // console.log("cccc",creditorderItems,cartItems)

      // await addDoc(orderRef, {
      //   // customer_name: selectedCreditCustomer.name,
      //   // customer_phone: selectedCreditCustomer.phone_no,
      //   customer_name: this.state.selectedData.label,
      //   customer_phone: this.state.selectedData.value,
      //   order_items: creditorderItems,
      //   total: totalWithServiceCharge,
      //   total_items: totalItems,
      //   order_no:orderNumber,
      //   ordered_at: timestamp,
      //   sub_total:total,
      //   process_code:0,
      //   print_status:0,
      //   paid_status:0,
      //   parcel_status:0,
      //   customer_id :customerID,
      //   creditUser_id:creditUserId
      //   // Add more properties as needed
      // });
      
      // Handle successful order submission to both databases
      console.log('Order submitted successfully to Firestore and Node.js');
    }

       
       
    
        console.log('Order posted to Firestore successfully!');
        const email = localStorage.getItem('emailId');
        console.log('shop admin:',email);
        const orderItemsString = JSON.stringify(orderItems);
        

        // const billHtml = ReactDOMServer.renderToString(<Bill order={order} />);
        const emailData = {
          to:[this.state.selectedData.mail,email],
          subject: `${this.state.selectedData.label} ordered new order from ${shopName}..!`,
        }

        const username = this.state.selectedData.label
        const shopID = localStorage.getItem('shopId')
        try {
          const response = await axios.post(`${var_api}/api/mailnotify/send-orderemail/${this.state.selectedData.mail}/${shopID}`, emailData);
          console.log('Email sent:', response.data);
          
        } catch (error) {
          console.error('Error sending email:', error);
          this.setState({iscredit:false});
        }

        this.setState({isCreditModal:false, isParcelChecked:false});
        this.setState({isOrderConfirmation:true});
    
      
        this.fetchAllOrdersHistory(this.state.selectedOrderLabel.value);
        this.fetchAllOrdersSummary(this.state.selectedOrderLabel.value);
         // Remove the items from the cartItems array
    this.setState({ cartItems: [] });
    
    this.clearSelectedValue();
    const audio = new Audio('https://spbiller.com/audio/place-order.mp3');
    audio.play();
       
        this.setState({iscredit:false});
    console.log('Cart items removed from state!');
    
  this.getExitingOrderNo();
      } catch (error) {
        console.error('Error posting order:', error);
        this.setState({iscredit:false});
      }
        // Fetch and display order history
        // this.fetchOrderHistory();
        
      
      }else{

        Swal.fire({
          icon:"error",
          title:"Oops...",
          text:"The order reached the credit limit",
          confirmButtonColor:"#007500"
        })
        }


      }else{
        Swal.fire({
          icon:"error",
          title:"Oops...",
          text:"Select Credit User",
          confirmButtonColor:"#007500"
        })
      }
    }
  }
  


 


  handleOpenRoomConfirmation = () => {
    //  //check cart is empty
    //  if(this.state.cartItems.length === 0){
    //   Swal.fire({
    //     icon:"error",
    //     title:"Oops...",
    //     text:"Your cart is empty. Please add items to your cart before placing an order.",
    //     confirmButtonColor:"#007500"
    //   })
    // }else{
      this.setState({ isNormalCreditModal: true});
    // }
    
  }

  handleGenerateNormalOrderModal = () => {
    //check cart is empty
    if(this.state.cartItems.length === 0){
     Swal.fire({
       icon:"error",
       title:"Oops...",
       text:"Your cart is empty. Please add items to your cart before placing an order.",
       confirmButtonColor:"#007500"
     })
   }else{

    if( this.state.selectedData.value && this.state.selectedData.label && this.state.selectedData.iden){
     this.setState({ isNormalCreditModal: true});
   }  else{
      Swal.fire({
        icon:"error",
        title:"Oops...",
        text:"Select Credit User",
        confirmButtonColor:"#007500"
      })
    }
   
 }
}



handleGeneratecreditOrderModal = () => {
  //check cart is empty
  if(this.state.cartItems.length === 0){
   Swal.fire({
     icon:"error",
     title:"Oops...",
     text:"Your cart is empty. Please add items to your cart before placing an order.",
     confirmButtonColor:"#007500"
   })
 }else{

  if( this.state.selectedData.value && this.state.selectedData.label && this.state.selectedData.iden){
    const user_balance = this.state.amountDetail.balance;
    const maxLimit = this.state.selectedData.maxCredit;
    const itemTotal = this.state.cartItems.reduce((accumulator, cartItem) => {
      return accumulator + cartItem.quantity * cartItem.food.price;
    }, 0);
    const totalAmount = user_balance + itemTotal;
    console.log("uuu",user_balance,maxLimit,itemTotal,totalAmount)

    if(maxLimit>=totalAmount){
   this.setState({ isCreditModal: true});
    }else{

      Swal.fire({
        icon:"error",
        title:"Oops...",
        text:"The order reached the credit limit",
        confirmButtonColor:"#007500"
      })
      }


 }  else{
    Swal.fire({
      icon:"error",
      title:"Oops...",
      text:"Select Credit User",
      confirmButtonColor:"#007500"
    })
  }
 
}
}



  generateOrder = async () => {
    const { cartItems, order_no, isParcelChecked } = this.state;


    //check cart is empty
    if(cartItems.length === 0){
      Swal.fire({
        icon:"error",
        title:"Oops...",
        text:"Your cart is empty. Please add items to your cart before placing an order.",
        confirmButtonColor:"#007500"
      })
    }
    else{

       // Calculate the total amount from cartItems
  const cartTotal = this.state.cartItems.reduce((accumulator, cartItem) => {
    return accumulator + cartItem.quantity * cartItem.food.price;
  }, 0);

  // Calculate the total amount from selectedAmounts
  const selectedTotal = this.state.selectedAmounts.reduce((accumulator, amount) => {
    return accumulator + amount;
  }, 0);

  
  console.log("amounts",cartTotal,selectedTotal)
      if(selectedTotal > 0){

        if(selectedTotal === cartTotal){

      const shopName = localStorage.getItem('shopName');
      this.setState({isLogin:true});
    // console.log("shop category:",shopName)
    // const orderRef = collection(db, `shops/${shopName}/orders`);
  
    const orderItems = this.state.cartItems.map((cartItem) => {
      return {
        food_id:cartItem.food.id,
        food_name: cartItem.food.food_name,
        quantity: cartItem.quantity,
        unit_price: cartItem.food.price,
        item_code: cartItem.food.item_code,
        category_code:cartItem.food.category_code,
        // Add more properties as needed
      };
    });

    const total = this.state.cartItems.reduce((accumulator, cartItem) => {
      return accumulator + cartItem.quantity * cartItem.food.price;
    }, 0);

    const totalWithServiceCharge = total + 0; // Add a service charge of 5 to the total
  
    // const totalItems = this.state.cartItems.reduce((accumulator, cartItem) => {
    //   return accumulator + cartItem.quantity;
    // }, 0);

    const totalItems = this.state.cartItems.length;

    
  
    try {
      // const timestamp = serverTimestamp();
      // const querySnapshot = await getDocs(orderRef);
      // const orderNumber = querySnapshot.size + 1;
      const currDate = new Date();
      const dd = String(currDate.getDate()).padStart(2, '0');
      const mm = String(currDate.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = currDate.getFullYear();
      
      const formattedDate = `${dd}-${mm}-${yyyy}`;
      const currTime = new Date().toLocaleTimeString();

      let maxOrderNo = 0;
      // if (order_no > maxOrderNo) {
      //   console.log("orderno",order_no)
      //    maxOrderNo = order_no;
      //   }
      // console.log("m",order_no)
      maxOrderNo = order_no.max_order_no + 1
      // console.log("m",maxOrderNo)
      

      // var customerName = document.querySelector('#name').value;
      // var customerPhone = document.querySelector('#mobile').value;

      var customerName = document.querySelector('#name') ? document.querySelector('#name').value : "-";
      var customerPhone = document.querySelector('#mobile') ? document.querySelector('#mobile').value : "-";
      var remark = document.querySelector('#remark') ? document.querySelector('#remark').value : "-";

  //     if(!this.state.isChecked){
        
  // const selectedCreditCustomer = JSON.parse( document.querySelector('#selectedCreditCustomer').value);
  //        customerName =selectedCreditCustomer.name;
  //      customerPhone = selectedCreditCustomer.phone_no;
  //     }

      // Validate name (only strings)
  // if (!/^[A-Za-z\s]+$/.test(customerName)) {
  //   alert('Invalid name. Please enter a valid name.');
  //   return;
  // }

  // Validate mobile number (only 10 digits)
  // if (!/^\d{5}$/.test(customerPhone)) {
  //   alert('Invalid mobile number. Please enter a 10-digit mobile number.');
  //   return;
  // }

const userID = localStorage.getItem('userId');
const empID = localStorage.getItem("admin_employee");
const userEmail = localStorage.getItem("emailId");
 const shop_id = localStorage.getItem('shopId');
     

      // Prepare the data to be sent to the Node.js API
      const orderData = {
        admin_id: parseInt(userID),
        admin_email: userEmail,
        shop_name:shopName,
        cust_name: customerName,
        phone_no: customerPhone,
        total_items:totalItems,
        order_no:maxOrderNo,
        total: totalWithServiceCharge,
        order_type:0,
        table_no:0,
        paid_status: 0,
        order_label:0,
        is_group_location_order:0,
        group_location_order_id:0,
        ordered_at:formattedDate,
        ordered_time:currTime,
        shop_id:shop_id,
        credit_user_id:0,
        items: orderItems,
        pay_mode: "-",
        remarks:remark,
        is_parcel: isParcelChecked ? 1 : 0,
        user_id:parseInt(userID),
        emp_id:parseInt(empID),
        kitchen_parcel_status:0
      };
      

       // Send the order data to the Node.js API using axios
  const response = await axios.post(`${var_api}/api/food/api/post`, orderData);
  if (response.status === 200) {
    console.log("customer id:", response.data.idUser);
    const customerId = response.data.idUser;



      // Create a new array with amounts inserted into matched pay modes
    const paymodesArray = this.state.payModes.map((mode, index) => {
      const amount = this.state.selectedAmounts[index] || 0; // Get amount from selectedAmounts array
      return { ...mode, amount, shop_id:shop_id, order_id: customerId, ordered_at:formattedDate  }; // Create a new object with amount inserted
    });

    console.log("amountwitharray",paymodesArray);

    try {
      const response = await axios.post(`${var_api}/api/order-paymode/post`, paymodesArray);
      console.log(response.data); // Log response from server
      console.log( "Succes", response.data.message );
      const entered_Paymodes = response.data.results;
      const enteredPaymodesString = entered_Paymodes.map(paymode => paymode.pay_mode_name).join(', ');
      this.setState({selectedAmounts:[], enteredPaymodes: enteredPaymodesString});
    } catch (error) {
      console.error('Error posting pay modes:', error);
    }



    const data = response.data.insertedTransIds;
    console.log("o.r",response.data)
    this.setState({orderResponse:response.data})

    // Extract the insertedTransIds array from the response
    console.log("transaction id", data);
    console.log('Order submitted successfully to Firestore and Node.js');

    // Clear the text fields by setting their values to an empty string
    document.querySelector('#name').value = '';
    document.querySelector('#mobile').value = '';
    document.querySelector('#remark').value = '';
    this.setState({isNormalModal:false, isParcelChecked:false});
    this.setState({isOrderConfirmation:true});

    // Play the notification sound
   // Play the notification sound
const audio = new Audio('https://spbiller.com/audio/place-order.mp3');
audio.play();

}


     
      this.setState({isLogin:false});
  
      console.log('Order posted to Firestore successfully!');

       // Remove the items from the cartItems array
  this.setState({ cartItems: [] });
  this.setState({ selectedItemCode: null});
  this.setState({ selectedPayMode: null});
  this.fetchAllOrdersHistory(this.state.selectedOrderLabel.value);
  this.fetchAllOrdersSummary(this.state.selectedOrderLabel.value);
  
this.getExitingOrderNo();


  console.log('Cart items removed from state!');
    } catch (error) {
      console.error('Error posting order:', error);
      this.setState({isLogin:false});
    }
      // Fetch and display order history
      // this.fetchOrderHistory();
  }
  else{
    Swal.fire({
      icon:"error",
      title:"Oops...",
      text:"pay mode amount is not equal to total amount",
      confirmButtonColor:"#007500"
    })
  }

}
  
  else{
        Swal.fire({
          icon:"error",
          title:"Oops...",
          text:"Enter the pay mode amount",
          confirmButtonColor:"#007500"
        })
      }
    }
  };


  generateNormalOrder = async () => {
    const { cartItems, order_no, isParcelChecked } = this.state;


    //check cart is empty
    if(cartItems.length === 0){
      Swal.fire({
        icon:"error",
        title:"Oops...",
        text:"Your cart is empty. Please add items to your cart before placing an order.",
        confirmButtonColor:"#007500"
      })
    }
    else{
      if( this.state.selectedData.value && this.state.selectedData.label && this.state.selectedData.iden){

         // Calculate the total amount from cartItems
  const cartTotal = this.state.cartItems.reduce((accumulator, cartItem) => {
    return accumulator + cartItem.quantity * cartItem.food.price;
  }, 0);

  // Calculate the total amount from selectedAmounts
  const selectedTotal = this.state.selectedAmounts.reduce((accumulator, amount) => {
    return accumulator + amount;
  }, 0);


        if(selectedTotal > 0){

          if(selectedTotal === cartTotal){

          const shopName = localStorage.getItem('shopName');
          this.setState({isLogin:true});
       
        const orderItems = this.state.cartItems.map((cartItem) => {
          return {
            food_id:cartItem.food.id,
            food_name: cartItem.food.food_name,
            quantity: cartItem.quantity,
            unit_price: cartItem.food.price,
            item_code: cartItem.food.item_code,
            category_code:cartItem.food.category_code,
            // Add more properties as needed
          };
        });
    
        const total = this.state.cartItems.reduce((accumulator, cartItem) => {
          return accumulator + cartItem.quantity * cartItem.food.price;
        }, 0);
    
        const totalWithServiceCharge = total + 0; // Add a service charge of 5 to the total
      
        
    
        const totalItems = this.state.cartItems.length;
    
        
      
        try {
          
          const currDate = new Date();
          const dd = String(currDate.getDate()).padStart(2, '0');
          const mm = String(currDate.getMonth() + 1).padStart(2, '0'); // January is 0!
          const yyyy = currDate.getFullYear();
          
          const formattedDate = `${dd}-${mm}-${yyyy}`;
          const currTime = new Date().toLocaleTimeString();
    
          let maxOrderNo = 0;
          // if (order_no > maxOrderNo) {
          //   console.log("orderno",order_no)
          //    maxOrderNo = order_no;
          //   }
          // console.log("m",order_no)
          maxOrderNo = order_no.max_order_no + 1
          // console.log("m",maxOrderNo)
          var remark = document.querySelector('#remark') ? document.querySelector('#remark').value : "-";
          const userID = localStorage.getItem('userId');
          const empID = localStorage.getItem("admin_employee")
          const userEmail = localStorage.getItem("emailId");
    
          // Prepare the data to be sent to the Node.js API
          const orderData = {
            admin_id: parseInt(userID),
            admin_email: userEmail,
            // admin_id: 33,
            // admin_email: "jesiugcs2019@gmail.com",
            shop_name:shopName,
            cust_name:  this.state.selectedData.label,
            phone_no: this.state.selectedData.value,
            total_items:totalItems,
            order_no:maxOrderNo,
            total: totalWithServiceCharge,
            order_type:0,
            table_no:0,
            paid_status: 0,
            order_label:0,
            is_group_location_order:0,
            group_location_order_id:0,
            ordered_at:formattedDate,
            ordered_time:currTime,
            shop_id:localStorage.getItem('shopId'),
            credit_user_id:this.state.selectedData.iden,
            items: orderItems,
            user_id:localStorage.getItem('userId'),
            emp_id: localStorage.getItem('admin_employee'),
            pay_mode: "-",
            remarks:remark,
            is_parcel: isParcelChecked ? 1 : 0,
            kitchen_parcel_status:0
          };
          
    
           // Send the order data to the Node.js API using axios
      const response = await axios.post(`${var_api}/api/food/api/post`, orderData);
      if (response.status === 200) {
    
        console.log("customer id:",response.data.idUser)
        const customerid = response.data.idUser;
    
        const data = response.data.insertedTransIds; 
        this.setState({orderResponse:response.data})
    
        // Extract the insertedTransIds array from the response
       console.log("transaction id",data);
       

        // Create a new array with amounts inserted into matched pay modes
    const paymodesArray = this.state.payModes.map((mode, index) => {
      const amount = this.state.selectedAmounts[index] || 0; // Get amount from selectedAmounts array
      return { ...mode, amount, shop_id:localStorage.getItem('shopId'), order_id: customerid, ordered_at:formattedDate  }; // Create a new object with amount inserted
    });

    console.log("amountwitharray",paymodesArray);


    try {
      const response = await axios.post(`${var_api}/api/order-paymode/post`, paymodesArray);
      console.log(response.data); // Log response from server
      console.log( "Succes", response.data.message );
      const entered_Paymodes = response.data.results;
      const enteredPaymodesString = entered_Paymodes.map(paymode => paymode.pay_mode_name).join(', ');
      this.setState({selectedAmounts:[], enteredPaymodes: enteredPaymodesString});
    } catch (error) {
      console.error('Error posting pay modes:', error);
    }

    
       document.querySelector('#remark').value = '';
       this.setState({ selectedPayMode: null});
       this.setState({isNormalCreditModal:false, isParcelChecked:false});
        this.setState({isOrderConfirmation:true});
    
        // Handle successful order submission to both databases
        console.log('Order submitted successfully to Firestore and Node.js');
        const audio = new Audio('https://spbiller.com/audio/place-order.mp3');
        audio.play();
    
      }
    
        
          this.setState({isLogin:false});
      
          console.log('Order posted to Firestore successfully!');
    
           // Remove the items from the cartItems array
      this.setState({ cartItems: [] });
      this.setState({ selectedItemCode: null});
      this.fetchAllOrdersHistory(this.state.selectedOrderLabel.value);
      this.fetchAllOrdersSummary(this.state.selectedOrderLabel.value);
      
    this.getExitingOrderNo();
    this.clearSelectedValue();
    
      console.log('Cart items removed from state!');
        } catch (error) {
          console.error('Error posting order:', error);
          this.setState({isLogin:false});
        }
          // Fetch and display order history
          // this.fetchOrderHistory();

        }
        else{
          Swal.fire({
            icon:"error",
            title:"Oops...",
            text:"pay mode amount is not equal to total amount",
            confirmButtonColor:"#007500"
          })
        }
      }else{
          Swal.fire({
            icon:"error",
            title:"Oops...",
            text:"Enter the pay mode Amount!",
            confirmButtonColor:"#007500"
          })
        }
        
    }
    else{
      Swal.fire({
        icon:"error",
        title:"Oops...",
        text:"Select Credit User",
        confirmButtonColor:"#007500"
      })
    }
  };
}

    handleAddCard = () => {
      // Navigate to a specific route using history.push
      this.props.history.push('/cate');
    };

    handleDropdownChange = (selectedOption) => {
      this.setState({ selectedData: selectedOption });
      console.log("credit user",selectedOption)
       // Perform validation checks here
    this.fetchCustomerBalance(selectedOption.iden)
    
    };

     // Function to update parcel status
  updateParcelInfo = (custId,id) => {

    const shopID = localStorage.getItem('shopId');
    const shopName = localStorage.getItem('shopName');

    const updatedData = {
     parcel_status:1,
    }


      // const orderRef = doc(db, `shops/${shopName}/orders`, id);
    
      // // Update the process_code field to 1
      // updateDoc(orderRef, {
      //   parcel_status:1,
      // })
      // .then(() => {
      //   console.log('process_code updated successfully');
      // })
      // .catch(error => {
      //   console.error('Error updating process_code:', error);
      // });

    axios
    .put(`${var_api}/api/food/parcelput/${shopID}/${custId}`, updatedData)
    .then((response) => {
      toast('Order added to parcel order',{autoClose:2000})
      console.log('Data updated successfully:', response.data.message);
      // Handle success, e.g., show a success message or update the UI
    })
    .catch((error) => {
      console.error('Error updating data:', error);
      // Handle error, e.g., show an error message or update the UI accordingly
    });
};


//update the print status
handlePrint = (id,orderId) => {

  const shopName = localStorage.getItem('shopName');
  // const orderRef = doc(db, `shops/${shopName}/orders`, orderId);

  // // Update the process_code field to 1
  // updateDoc(orderRef, {
  //   print_status: 1
  // })
  // .then(() => {
  //   console.log('process_code updated successfully');
  // })
  // .catch(error => {
  //   console.error('Error updating process_code:', error);
  // });
  
  const shopID = localStorage.getItem('shopId');
   
  const updatedStatus = {
    print_status:1,
   }

   axios
   .put(`${var_api}/api/food/put/print/${shopID}/${id}`, updatedStatus)
   .then((response) => {
    //  Swal.fire({
    //    text:"print status updated",
    //    confirmButtonColor:"#007500"
    //  })
    toast('print status updated',{autoClose:2000})
     console.log('Data updated successfully:', response.data.message);
   })
   .catch((error) => {
     console.error('Error updating data:', error);
     // Handle error, e.g., show an error message or update the UI accordingly
   });
  // this.setState({ isPrinted: true }); // Set the state to indicate that the button has been clicked
  // // Call the ReactToPrint logic here if needed
};


//to update paid status to 1
handlePaidStatus = (id,orderId) => {

  const shopName = localStorage.getItem('shopName');
  // const orderRef = doc(db, `shops/${shopName}/orders`, orderId);

  // // Update the process_code field to 1
  // updateDoc(orderRef, {
  //   paid_status: 1
  // })
  // .then(() => {
  //   console.log('process_code updated successfully');
  // })
  // .catch(error => {
  //   console.error('Error updating process_code:', error);
  // });
  
  const shopID = localStorage.getItem('shopId');
   
  const updatedStatus = {
    paid_status:1,
   }

   axios
   .put(`${var_api}/api/food/put/paidstatus/${shopID}/${id}`, updatedStatus)
   .then((response) => {
    //  Swal.fire({
    //    text:"paid status updated",
    //    confirmButtonColor:"#007500"
    //  })
     toast('paid status updated',{autoClose:2000})
     console.log('Data updated successfully:', response.data.message);
   })
   .catch((error) => {
     console.error('Error updating data:', error);
     // Handle error, e.g., show an error message or update the UI accordingly
   });
  // this.setState({ isPrinted: true }); // Set the state to indicate that the button has been clicked
  // // Call the ReactToPrint logic here if needed
};



//to update paid status to 1
handleCancelStatus = (id,orderId) => {

  const shopName = localStorage.getItem('shopName');
  // const orderRef = doc(db, `shops/${shopName}/orders`, orderId);

  // // Update the process_code field to 1
  // updateDoc(orderRef, {
  //   paid_status: 2
  // })
  // .then(() => {
  //   console.log('process_code updated successfully');
  // })
  // .catch(error => {
  //   console.error('Error updating process_code:', error);
  // });
  
  const shopID = localStorage.getItem('shopId');
   
  const updatedStatus = {
    paid_status:2,
   }

   axios
   .put(`${var_api}/api/food/put/paidstatus/${shopID}/${id}`, updatedStatus)
   .then((response) => {
    toast('order cancelled',{autoClose:2000})
     console.log('Data updated successfully:', response.data.message);
   })
   .catch((error) => {
     console.error('Error updating data:', error);
     // Handle error, e.g., show an error message or update the UI accordingly
   });
  // this.setState({ isPrinted: true }); // Set the state to indicate that the button has been clicked
  // // Call the ReactToPrint logic here if needed
};


handleOrderLabelSelectChange = (selectedOption) => {
  this.setState({ selectedOrderLabel: selectedOption });
  this.fetchAllOrdersHistory(selectedOption.value);
  this.fetchAllOrdersSummary(selectedOption.value)
}


//onchange function for payment mode
handlePayModeSelectChange = (selectedOption) => {
  this.setState({ selectedPayMode: selectedOption });
  console.log(selectedOption)
}

handleStartDateChange = (event) => {
  const startDate = event.target.value;
  // Split the date string into year, month, and day
 const [year, month, day] = startDate.split('-');
 // Create a new date string with the desired format
 const formattedDate = `${day}-${month}-${year}`;
 // Do whatever you want with the formatted date
 console.log('Formatted date:', formattedDate);
  // Do something with the start date, e.g., store it in state
  this.setState({ startDate:formattedDate });
  
}

handleEndDateChange = (event) => {
  const endDate = event.target.value;
  // Split the date string into year, month, and day
 const [year, month, day] = endDate.split('-');
 // Create a new date string with the desired format
 const formattedDate = `${day}-${month}-${year}`;
 // Do whatever you want with the formatted date
 console.log('Formatted date:', formattedDate);
  // Do something with the end date, e.g., store it in state
  this.setState({ endDate:formattedDate });
  
}


handleOpenSelectDate = () => {
  this.setState ({isOpenSelectDate:true});
}


handleCloseDateConfirmation = () => {
  this.setState ({isOpenSelectDate:false});
}

handleSelectDateRange = () => {
  this.fetchAllOrdersHistory(this.state.selectedOrderLabel.value);
  this.setState ({isOpenSelectDate:false});
  this.fetchAllOrdersSummary(this.state.selectedOrderLabel.value)
  
}

formatDate(dateString) {
  const [day, month, year] = dateString.split('-');
  return `${year}-${month}-${day}`;
}

//open the summary modal
handleOpenOrderSumModal = () => {
  this.setState({isOpenOrderSummary:true});
}


//close the summary modal
handleCloseSummaryConfirmation = () => {
  this.setState({isOpenOrderSummary:false});
}


//close the summary modal
handleCloseNormalConfirmation = () => {
  this.setState({isNormalModal:false});
}


//close the summary modal
handleCloseNormalCreditConfirmation = () => {
  this.setState({isNormalCreditModal:false});
}


//close the summary modal
handleCloseCreditConfirmation = () => {
  this.setState({isCreditModal:false});
}


//close the summary modal
handleChangeRoom = () => {
  this.setState({isRoom:true});
}


//close the summary modal
handleChangeSeat = () => {
  this.setState({isRoom:false});
}



//close the summary modal
handleCloseInstantAdding = () => {
  this.setState({isOpenAddInstant:false});
}


//close the summary modal
handleCloseaPayModeEdit = () => {
  this.fetchAllOrdersHistory(this.state.selectedOrderLabel.value);
  this.setState({isPayModeEdit:false});
}



// Function to handle checkbox change
handleCheckboxChange = () => {
  // Update state to toggle isChecked value
  this.setState(prevState => ({
    isParcelChecked: !prevState.isParcelChecked
  }));
};

//switch for image status onchange
handleSwitchToggle() {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
}

//to open the  edit modal
handleOpenEditPayModal = (order) => {
  // Sort pay_modes in ascending order based on pay_mode_id
  const sortedPayModes = order.pay_modes.sort((a, b) => a.paymode_id - b.paymode_id);

  this.setState({isPayModeEdit:true, editPaymodeOrder:order, editSelectedAmounts:sortedPayModes, editpaymode: {label:order.pay_mode, value: order.pay_mode}, updateRemark:order.remarks});
  console.log("paymodd order",order);
  console.log("editSelectedAmounts",this.state.editSelectedAmounts, order.pay_modes);
  console.log("editSelectedAmounts", sortedPayModes);
}


//onchange the edit modal
handlePayModeEditChange = (selectedOption) => {
  this.setState({ editpaymode: selectedOption });
  console.log(selectedOption)
}

// Update the remark value in state when input changes
handleRemarkChange = (event) => {
  this.setState({ updateRemark: event.target.value });
};


//update method for paymode
handleUpdatePaymode = () => { 
const ModeTotal = this.state.editSelectedAmounts && this.state.editSelectedAmounts.reduce((sum, currentItem) => sum + currentItem.amount, 0)
  if(this.state.editPaymodeOrder.total !== ModeTotal){
    Swal.fire({
            icon:"error",
            title:"Oops...",
            text:"Paymode Total is not Equal to Total Amount",
            confirmButtonColor:"#007500"
          })

  }
  else{
  this.setState({isPayModeEditLoading:true});
  const shopID = localStorage.getItem('shopId');

   console.log("update",this.state.editSelectedAmounts)
   const paymodesArray = this.state.editSelectedAmounts.map((mode, index) => ({
    amount:  mode.amount ? mode.amount : 0,
    id: mode.id,
    shop_id: parseInt(shopID),
    remarks : this.state.updateRemark,
    order_id:mode.order_id
}));


   axios
   .put(`${var_api}/api/order-paymode/edit-order-paymodes`, paymodesArray)
   .then((response) => {
  
     toast('Updated Successfully',{autoClose:2000});
     this.fetchAllOrdersHistory(this.state.selectedOrderLabel.value);
     this.setState({isPayModeEdit:false,isPayModeEditLoading:false});
     console.log('Data updated successfully:', response.data.message);
   })
   .catch((error) => {
     console.error('Error updating data:', error);
     this.setState({isPayModeEditLoading:false});
     // Handle error, e.g., show an error message or update the UI accordingly
   });
  }
};





//onclick method paymode card
handleCardClick = (id) => {
  const { cartItems } = this.state;
  // Find the index of the pay mode with the given ID
  const index = this.state.payModes.findIndex(mode => mode.id === id);
  console.log("inddx", index,this.state.payModes);
  

  const total= cartItems.reduce((accumulator, cartItem) => {
    return accumulator + cartItem.quantity * cartItem.food.price;
  }, 0);

    // Create an array to hold the new amounts, initialized with zeros
    const newSelectedAmounts = Array(this.state.payModes.length).fill(0);
 
  // Set the amount for the clicked pay mode
  newSelectedAmounts[index] = total; // Set the initial value here
 
  // Update the state
  this.setState({ selectedAmounts: newSelectedAmounts, isAmountSetByCardClick: true });

  console.log("after setting", newSelectedAmounts, this.state.isAmountSetByCardClick);
}



handleEditCardClick = (id, total) => {
  const { editSelectedAmounts } = this.state;
  // Find the index of the pay mode with the given ID
  const index = this.state.editSelectedAmounts.findIndex(mode => mode.id === id);
  console.log("inddx", index,this.state.editSelectedAmounts);
  
  const updatedEditSelectedAmounts = editSelectedAmounts.map(item => ({
    ...item,
    amount: 0
}));

if (index !== -1) {
  updatedEditSelectedAmounts[index].amount = total;
}

// Update the component state with the new array
this.setState({ editSelectedAmounts: updatedEditSelectedAmounts });
 
 
  console.log("after setting", updatedEditSelectedAmounts);
}


handleEditAmountChange = (index, value) => {
 const newSelectedAmounts = [...this.state.editSelectedAmounts];

  // Convert the value to a number
  const newValue = value !== '' ? parseInt(value) : 0;
  // Check if the value is 0 and the user wants to clear it
  if (newValue === 0) {
    newSelectedAmounts[index].amount  = null; // Set the value to an empty string
  } else {
    // Update the quantity at the specified index
    newSelectedAmounts[index].amount = newValue;
  }
  // Set the amount for the corresponding index
  // newSelectedAmounts[index].amount = parseFloat(value) || 0;
  console.log("after setting textfield", newSelectedAmounts);
  // Clear the card clicked index
  this.setState({ editSelectedAmounts: newSelectedAmounts});
}


handleAmountChange = (index, value) => {

  // Check if the amount is being set due to card clicking
  // if (this.state.isAmountSetByCardClick) {
  //    // Create an array to hold the new amounts, initialized with zeros
  //    const newSelectedAmounts = Array(this.state.payModes.length).fill(0);
  //    console.log("if", newSelectedAmounts);
  //   // Reset the flag
  //   this.setState({ selectedAmounts: newSelectedAmounts, isAmountSetByCardClick: false });
  // }
 // Create a copy of the current selectedAmounts array
 const newSelectedAmounts = [...this.state.selectedAmounts];

   // Convert the value to a number
  const newValue = value !== '' ? parseInt(value) : 0;

  // Check if the value is 0 and the user wants to clear it
  if (newValue === 0) {
    newSelectedAmounts[index] = null; // Set the value to an empty string
  } else {
    // Update the quantity at the specified index
    newSelectedAmounts[index] = newValue;
  }
  console.log("after setting textfield", newSelectedAmounts);
  // Clear the card clicked index
  this.setState({ selectedAmounts: newSelectedAmounts});
}



// //to open the confirm seat
// handletoOpenConfrimSeat = (roomId, roomName) => {
//   this.setState({ isOpenAddInstant: true, selectedRoomId: roomId, selectedRoomName: roomName});
// }


//onchange function for instant food name
handleInstandFoodChange(event) {
  this.setState({
    instantFoodName : event.target.value
  });
}


//onchange function for instant quantity
handleInstandQuantityChange(event) {
  this.setState({
    instantQuantity : event.target.value
  });
}


//onchange function for instant price
handleInstandPriceChange(event) {
  this.setState({
    instantPrice : event.target.value
  });
}


//to adding instant food in cart items
handleToInstantAddingFood = () => {
  const { cartItems, instantFoodName, instantQuantity, instantPrice } = this.state;
  if(instantFoodName && instantQuantity && instantPrice && instantPrice > 0 && instantQuantity > 0){
const existingItemIndex = cartItems.findIndex((item) => item.food.food_name === instantFoodName);

if (existingItemIndex !== -1) {
const updatedCartItems = [...cartItems];
updatedCartItems[existingItemIndex].quantity += instantQuantity;
this.setState({ cartItems: updatedCartItems });
this.setState({ isOpenAddInstant: false, instantFoodName:null, instantQuantity:null, instantPrice:null});
} else {

const food = {
   food_name: instantFoodName,
   price: instantPrice || 1,
   category_code:" ",
   category_id:0,
   cost:0,
   currency:" ",
   id:0,
   image:" ",
   item_code:`instant+${instantFoodName}`,
   uom:" "
}
const cartItemId = Date.now();
this.setState((prevState) => ({
  cartItems: [...prevState.cartItems, {  id: cartItemId,food: food, quantity: instantQuantity }],
}));
this.setState({ isOpenAddInstant: false, instantFoodName:null, instantQuantity:null, instantPrice:null});
 }
console.log("cc",cartItems);
  }else{
    toast('Please Check the values',{autoClose:2000})
  }
};
    
    

    // fetchData = async () => {
    //   const data = localStorage.getItem('userId')
    //  try {
    //   const response = await axios.get('http://localhost:4300/api/shop/shopData/'+data );
    //   // Assuming setUsers is a function to update your state with the response data.
    //   const use = response.data
    //   // const use = [response.data.id,response.data.name,response.data.email,response.data.password,response.data.country,response.data.mobile]
    //   console.log(use)
    //   this.users(use);
    // }catch (error) {
    //   console.log('Error fetching data:', error);
      
    //   }
    // };




    //handle to cart
    handleAddToCart = (subCategory) => {
      this.setState((prevState) => {
        const isAlreadyInCart = prevState.serviceCart.some(
          (item) => item.id === subCategory.id
        );
    
        if (isAlreadyInCart) {
          return null; // Do nothing if the item is already in the cart
        }
    
        const newService = { ...subCategory, additionalPrice: 0, additionalDuration: 0 };
        const updatedCart = [...prevState.serviceCart, newService];
    
        // Save updated cart to localStorage
        localStorage.setItem('serviceCart', JSON.stringify(updatedCart));
    
        return { serviceCart: updatedCart };
      });
    };
    

    //calculate sub total for cart service amount
    // calculateSubtotal = () => {
    //   const { serviceCart } = this.state;
    //   return serviceCart.reduce((total, item) => total + parseFloat(item.service_price) + parseFloat(item.additionalPrice), 0).toFixed(2);
    // };
    calculateSubtotal = () => {
      const { serviceCart } = this.state;
      return serviceCart.reduce((total, item) => {
        // Use parseFloat and provide a default value of 0 if the value is not a valid number
        const servicePrice = parseFloat(item.service_price) || 0;
        const additionalPrice = parseFloat(item.additionalPrice) || 0;
        
        return total + servicePrice + additionalPrice;
      }, 0).toFixed(2);
    };



    //handle to remove the service in a cart
    handleRemoveFromCart = (subCategoryId) => {
      this.setState((prevState) => {
        // Filter out the item to be removed from the cart
        const updatedCart = prevState.serviceCart.filter(item => item.id !== subCategoryId);
        
        // Update local storage with the new cart
        localStorage.setItem('serviceCart', JSON.stringify(updatedCart));
        
        return { serviceCart: updatedCart };
      }, () => {
        // Callback function after state has been updated
        if (this.state.serviceCart.length === 0) {
          alert("All services have been removed from the cart.");
          this.setState({
            isOpenAddInstant: false,
            showCanvas: false,
            isCreditModal: false,
            customerName: null,
            customerMobile: null,
            dob: null,
            checkedItems: {}
          });
          return;
        }
        console.log("Cart length:", this.state.serviceCart.length);
      });
    };

    //reset the bookign details
    handleGenerateOrderModalReset = () => {
      this.setState({ customerName: '',
        customerMobile: '',
        dob: '',
        email:'',
        gender:'',
        serviceCart: [],
      mobileOptions:[],
      isDobChecked: false});
      localStorage.removeItem('serviceCart');
    }
    

    //handle to book service
    handleGenerateOrderModal = () => {
      console.log("namo",this.state.customerName, this.state.customerMobile)
       //check cart is empty
       if (!this.state.customerName) {
        alert('Customer name is required.');
        return;
      }
      if (!this.state.customerMobile ) {
        alert('Customer mobile number is required.');
        return;
      }

      if (!this.state.gender ) {
        alert('Customer gender number is required.');
        return;
      }
      //check cart is empty
      if(this.state.serviceCart.length === 0){
       Swal.fire({
         icon:"error",
         title:"Oops...",
         text:"Your cart is empty. Please add services to your cart before booking an order!",
         confirmButtonColor:"rgba(103,120,95,1)"
       })
     }else{
         // Filter services based on selected gender
        // const updatedServiceCart = this.state.serviceCart.filter(service => service.gender === this.state.gender);
        // console.log("cart now", this.state.serviceCart, updatedServiceCart)
          //check cart is empty
      // if(updatedServiceCart.length === 0){
      //   Swal.fire({
      //     icon:"error",
      //     title:"Oops...",
      //     text:"Your cart is empty. Please add services to your cart before booking an order!",
      //     confirmButtonColor:"rgba(103,120,95,1)"
      //   })
      // } else{
        this.setState({ isCreditModal: true
          // , serviceCart: updatedServiceCart
        });
      // }
      
     }
     
   }


   handleNameChange(event) {
    this.setState({ customerName: event.target.value });
  }

  handleMobileChange = (selectedOption) => {
    console.log("se", selectedOption)
    if (selectedOption) {
      console.log("se1", selectedOption.dob);
      let formattedDOB = "";
      if (selectedOption.dob) {
        const dateParts = selectedOption.dob.split('-');
        if (dateParts.length === 3) {
          const day = parseInt(dateParts[0], 10);
          const month = parseInt(dateParts[1], 10) - 1; // Months are zero-based in JavaScript
          const year = parseInt(dateParts[2], 10);
  
          const date = new Date(Date.UTC(year, month, day));
        console.log("Da",date)
        if (!isNaN(date.getTime())) { // Check if the date is valid
          formattedDOB = date.toISOString().slice(0, 10);
          console.log("formattedDOB", formattedDOB,!isNaN(date.getTime())) 
        }else {
          console.error('Invalid date of birth:', selectedOption.dob);
        }
      } else {
        console.error('Invalid date format:', selectedOption.dob);
      }
      }
      this.setState({ customerMobile:  selectedOption.label, customerName: selectedOption.value,  dob: formattedDOB, isDobChecked: !!formattedDOB, gender:selectedOption.gender, email: selectedOption.email });
    } else {
      this.setState({ customerMobile: "", customerName: "" , dob: "", isDobChecked: false});
    }
  };

 
  handleInputChange = (inputValue) => {
    if (inputValue && inputValue.length >= 2) {
      this.fetchMobileNumber(inputValue);
    }
    this.setState({ customerMobile: inputValue || this.state.customerMobile }); // Ensure customerMobile is always a string
  };

  handleMobileTextChange(event) {
    const mobile = event.target.value;
    this.setState({ customerMobile: mobile }); // Update customerMobile state
    if (mobile.length >= 2) {
      this.fetchMobileNumber(mobile); // Fetch mobile number if length is sufficient
    } else {
      this.setState({ mobileOptions: [] }); // Clear options if input length is less than 2
    }
  }

  fetchMobileNumber = async (mobileNumber) => {
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `${token}`,
    };
    try {
      const response = await axios.get(`${var_api}/api/customer-details/get-name/${mobileNumber}`, { headers });
      const data = response.data;
      console.log('Fetching data:', data);

      if (Array.isArray(data) && data.length > 0) {
        const mobiles = data.map(cust => ({
          label: cust.customer_mobile,
          value: cust.customer_name,
          dob: cust.dob,
          email: cust.email,
          gender: cust.gender
        }));
        this.setState({ mobileOptions: mobiles });
      }
      if (data.exStatus === false) {
        this.setState({ mobileOptions: [] });
      }
    } catch (error) {
      console.log('Error fetching data:', error);
      if (error.response && error.response.status === 401) {
        this.props.history.push('/signin');
    }
    }
  };


  handleDobChange(event) {
    this.setState({ dob: event.target.value });
  }


  handleCheckboxDobChange(event) {
    this.setState({ isDobChecked: event.target.checked });
  }


   // Function to format date from yyyy-mm-dd to dd-mm-yyyy
   formatDate(dateString) {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  }

  formatDates(date) {
    if (!date) {
        console.error("Date is undefined or null");
        return "00-00-0000"; // Fallback value if date is invalid
    }
    
    if (typeof date === 'string') {
        // If the date is a string, ensure it's in the expected format
        // Example: '2024-10-15' should be converted to '15-10-2024'
        const parts = date.split('-');
        if (parts.length !== 3) {
            console.error("Date format is incorrect", date);
            return "00-00-0000"; // Fallback if format is incorrect
        }
        return `${parts[2]}-${parts[1]}-${parts[0]}`; // Change the order to DD-MM-YYYY
    } else if (date instanceof Date) {
        // If the input is a Date object, format it accordingly
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`; // Return formatted date as DD-MM-YYYY
    } else {
        console.error("Date is not a string or Date object", date);
        return "00-00-0000"; // Fallback for unexpected types
    }
}


async fetchTaxMaster() {
  try {
    this.setState({ loading: true });

    const tokens = localStorage.getItem("token");
    const response = await axios.get(`${var_api}/api/tax-master/admin-active-list`, {
      headers: {
        Authorization: `${tokens}`,
      },
    });

    this.setState({ taxData: response.data });
  } catch (error) {
    console.error("Error fetching tax data:", error);
  } finally {
    this.setState({ loading: false });
  }
}


//add booking service
async handleSubmit(event) {
  event.preventDefault();
  console.log("cart", this.state.serviceCart);

  // Check if the cart is empty
  if (this.state.serviceCart.length === 0) {
      alert('Please select at least one service!');
      this.setState({ isOpenAddInstant: false, showCanvas: false, isCreditModal: false });
      return;
  }

  // Validation: Check if all required fields are provided for each service
  const incompleteService = this.state.serviceCart.some(service =>
      !service.from_time || !service.to_time || !service.employee_id
  );

  if (incompleteService) {
      alert('Please ensure that from time, to time, and beautician are provided for each service.');
      return;
  }

  const fromTimeValues = this.state.serviceCart.map(service => service.from_time);
    const hasDuplicateFromTime = fromTimeValues.some((time, index) => 
        fromTimeValues.indexOf(time) !== index
    );

    if (hasDuplicateFromTime) {
        alert('Please select different time slots for each service.');
        return;
    }

    // Check for overlapping time slots
    const sortedServices = this.state.serviceCart.sort((a, b) => {
      // Sort services by 'from_time'
      const [aHour, aMinute] = a.from_time.split(':').map(Number);
      const [bHour, bMinute] = b.from_time.split(':').map(Number);
    
      return aHour * 60 + aMinute - (bHour * 60 + bMinute);
    });
    
    // Check for overlapping time slots and if the next service starts after the current service's "To Time"
    for (let i = 0; i < sortedServices.length - 1; i++) {
      const [currentEndHour, currentEndMinute] = sortedServices[i].to_time.split(':').map(Number);
      const [nextStartHour, nextStartMinute] = sortedServices[i + 1].from_time.split(':').map(Number);
    
      const currentServiceEndTimeInMinutes = currentEndHour * 60 + currentEndMinute;
      const nextServiceStartTimeInMinutes = nextStartHour * 60 + nextStartMinute;
    
      // Check if the next service starts after the current service's end time
      if (nextServiceStartTimeInMinutes <= currentServiceEndTimeInMinutes) {
        alert(`The start time for service ${i + 2} must be after the end time of service ${i + 1}. Please select a valid time.`);
        return;
      }
    }

  this.setState({ isLoader: true });

  const token = localStorage.getItem('token');
  const config = {
      headers: { Authorization: `${token}` }
  };

  const roomServices = this.state.serviceCart
      .filter(service => service.type === 'room')
      .map(service => ({
          employee_id: service.employee_id,
          employee_name: service.employee_name,
          room_id: service.room_id,
          room_name: service.room_name,
          service_id: service.id,
          service_name: service.service_name,
          service_cost: service.service_price ,
          service_duration: parseInt(service.service_duration),
          room_start_time: service.from_time,
          room_end_time: service.to_time,
          additional_cost: service.additionalPrice || 0,
          additional_duration: service.additionalDuration || 0
      }));

  const seatServices = this.state.serviceCart
      .filter(service => service.type === 'seat')
      .map(service => ({
          employee_id: service.employee_id,
          employee_name: service.employee_name,
          seat_id: service.seat_id,
          seat_name: service.seat_name,
          service_id: service.id,
          service_name: service.service_name,
          service_cost: service.service_price,
          service_duration: parseInt(service.service_duration),
          seat_start_time: service.from_time,
          seat_end_time: service.to_time,
          additional_cost: service.additionalPrice || 0,
          additional_duration: service.additionalDuration || 0
      }));

      console.log("tot",parseInt(this.calculateSubtotal()));
      await this.fetchTaxMaster(); // Ensure tax data is available

  const totalAmount = parseInt(this.calculateSubtotal());

  // Prepare the taxes array
  const taxes = this.state.taxData.map(tax => ({
      tax_id: tax.id,
      tax_name: tax.tax_name,
      tax_value: tax.tax_value,
      tax_amount: (tax.tax_value / 100) * totalAmount // Calculate tax amount based on total amount
  }));

  try {
      const response = await axios.post(`${var_api}/api/confirm_booking/post`, {
          customer_name: this.state.customerName,
          customer_mobile: this.state.customerMobile,
          dob: this.formatDate(this.state.dob) || "00-00-0000",
          total_amount: parseInt(this.calculateSubtotal()),
          order_date: this.formatDates(this.state.todayDateInput), // Use the selected date without validation
          orders: roomServices,
          seat_orders: seatServices,
          email: this.state.email,
          gender: this.state.gender,
          taxes: taxes
      }, config);

      // Show success message
      alert('Booking confirmed successfully!');
      const booking_id = response.data.id;

      // Clear localStorage after successful booking
      localStorage.removeItem('serviceCart'); // Remove serviceCart from localStorage
      // Or use localStorage.clear() to remove all data in localStorage, if necessary

      // Refresh data
      this.fetchRoomData(this.state.todayDateInput);
      this.fetchSeatData(this.state.todayDateInput);
      this.fetchData();
      this.fetchSummaryData();
      this.setState({ isLoader: false });

      // After successful submission, call booknowAdvance and pass the same payload data
      await this.booknowAdvance(roomServices, seatServices, booking_id);

      console.log("success", response.data.message);

      // Reset state
      this.setState({
          customerName: '',
          customerMobile: '',
          dob: '',
          email:'',
          gender:'',
          serviceCart: [],
          checkedItems: {},
          from_time: '',
          to_time: '',
          beautician: null,
          validationError: '',
          startDate: '', 
          selectedData: '',
          isCreditModal: false,
          isOpenAddInstant: false,
          showCanvas: false
      });
  } catch (error) {
      console.error('There was an error!', error);
      this.setState({ isLoader: false });
      if (error.response && error.response.status === 401) {
          this.props.history.push('/signin');
      }
  }
}




  async booknowAdvance(roomServices, seatServices, booking_id) {
    const userid = localStorage.getItem('userId');
    const currentDate = new Date();
    const bookingTime = currentDate.toTimeString().split(' ')[0];
  
    const services = [
      ...roomServices.map(service => ({
        service_id: service.service_id,
        service_name: service.service_name,
        price: service.service_cost,
        duration: service.service_duration,
        from_time: service.room_start_time,
        to_time: service.room_end_time,
        emp_id: service.employee_id // Assuming you want the emp_id from roomServices
      })),
      ...seatServices.map(service => ({
        service_id: service.service_id,
        service_name: service.service_name,
        price: service.service_cost,
        duration: service.service_duration,
        from_time: service.seat_start_time,
        to_time: service.seat_end_time,
        emp_id: service.employee_id // Assuming you want the emp_id from seatServices
      }))
    ];
    
    // Get all from_time and to_time from roomServices and seatServices
const allFromTimes = [
  ...roomServices.map(service => service.room_start_time),
  ...seatServices.map(service => service.seat_start_time)
];

const allToTimes = [
  ...roomServices.map(service => service.room_end_time),
  ...seatServices.map(service => service.seat_end_time)
];


// Find the smallest from_time and the largest to_time
const smallestFromTime = allFromTimes.reduce((minTime, currentTime) => currentTime < minTime ? currentTime : minTime);
const largestToTime = allToTimes.reduce((maxTime, currentTime) => currentTime > maxTime ? currentTime : maxTime);

// Create the slot time in the desired format
const slotTime = `${smallestFromTime} - ${largestToTime}`;

  
    // Create a new payload for booknowAdvance with the same data
    const payload = {
      booking_type: 2,
      user_id: parseInt(userid),
      customer_id: 0,
      emp_id: 0,
      is_coupon: 0,
      coupon_id: 0,
      customer_name: this.state.customerName,
      customer_mobile: this.state.customerMobile,
      booking_date: this.formatDate(this.state.todayDateInput),
      booking_time: bookingTime,
      slot_time: slotTime,
      status: 0,
      total_amount:parseInt(this.calculateSubtotal()), // Use total amount from payload
      services: services,
      sage_id:booking_id
    };
  
    try {
      const response = await axios.post(
        `${var_api}/api/shop-sage-booking`,
        payload
      );
  
      console.log(response.data);
  
     
      alert("Success! Your booking has been confirmed.");
  
    } catch (error) {
      console.error("Error booking advance:", error);
      alert("Error: Unable to book.");
    }
  }
  

  //to open the confirm room
handletoOpenConfirmRoom = (roomId, roomName, selectedTime) => {
  this.setState({ isOpenAddInstant: true, selectedRoomId: roomId, selectedRoomName: roomName, selectedTime: selectedTime},() => {
    // Call the API after setting the state
    this.getTimeInterval();
    this.getTypeBooking();
  });
}


//to open the confirm room
handletoOpenConfirmSeat = (seatId, seatName) => {
  this.setState({ isOpenAddInstant: true, selectedSeatId: seatId, selectedSeatName: seatName},() => {
    // Call the API after setting the state
    this.getTimeInterval();
    this.getTypeBooking();
  });
}


  // handleCheckboxChangeService(event, index, service) {
  //   const { checked } = event.target;
  //   const { serviceCart,activeTab } = this.state;
    
  //   if (checked) {
  //     // Add room_name and room_id to the service object
  //     serviceCart[index].room_name = this.state.selectedRoomName;
  //     serviceCart[index].room_id = this.state.selectedRoomId;
  //   } else {
  //     // Remove room_name and room_id if checkbox is unchecked
  //     delete serviceCart[index].room_name;
  //     delete serviceCart[index].room_id;
  //   }

  //   // Update the checked status of the checkbox
  //   this.setState(prevState => ({
  //     checkedItems: {
  //       ...prevState.checkedItems,
  //       [index]: checked
  //     },
  //     serviceCart: [...serviceCart]
  //   }));
  //   console.log("after checked", this.state.serviceCart, this.state.checkedItems);
  // }


  handleCheckboxChangeService(event, index, service) {
    const { checked } = event.target;
    const { serviceCart, activeTab, selectedRoomName, selectedRoomId, selectedSeatName,from_time, to_time, selectedSeatId, beautician } = this.state;
    console.log("tab",activeTab)
    
    if (checked) {
        if (activeTab === "1") {
            // Add room_name and room_id to the service object if activeTab is 1
            serviceCart[index] = {
                ...serviceCart[index],
                room_name: selectedRoomName,
                room_id: selectedRoomId,
                from_time,
                to_time,
                employee_id: beautician?.value,
                employee_name: beautician?.label,
                type:'room'
            };
        } else {
            // Add seat_name and seat_id to the service object if activeTab is 2
            serviceCart[index] = {
                ...serviceCart[index],
                seat_name: selectedSeatName,
                seat_id: selectedSeatId,
                from_time,
                to_time,
                employee_id: beautician?.value,
                employee_name: beautician?.label,
                type:'seat'
            };
        }
    } else {
        // Remove room_name and room_id if activeTab is 1 and checkbox is unchecked
        if (activeTab === "1") {
            delete serviceCart[index].room_name;
            delete serviceCart[index].room_id;
            delete serviceCart[index].type;
            delete serviceCart[index].from_time;
            delete serviceCart[index].to_time;
            delete serviceCart[index].employee_id;
            delete serviceCart[index].employee_name;
            delete serviceCart[index].seat_name;
            delete serviceCart[index].seat_id;
        }
        // Remove seat_name and seat_id if activeTab is 2 and checkbox is unchecked
        else {
            delete serviceCart[index].seat_name;
            delete serviceCart[index].seat_id;
            delete serviceCart[index].type;
            delete serviceCart[index].from_time;
            delete serviceCart[index].to_time;
            delete serviceCart[index].employee_id;
            delete serviceCart[index].employee_name;
            delete serviceCart[index].room_name;
            delete serviceCart[index].room_id;
        }
    }

    // Update the checked status of the checkbox
    this.setState(prevState => ({
        checkedItems: {
            ...prevState.checkedItems,
            [index]: checked
        },
        serviceCart: [...serviceCart]
    }));

    console.log("after checked", this.state.serviceCart, this.state.checkedItems);
}


fetchRoomData = async (todayDateInput) => {
  const token = localStorage.getItem('token'); 
    const config = {
      headers: { Authorization:` ${token}`}
    };
    const formattedDate = todayDateInput.split('-').reverse().join('-');
  try {
     const response = await axios.get(`${var_api}/api/room-status/get/${formattedDate}`, config);
    const user =response.data;

     if (Array.isArray(user)) {
      this.setState({ 
        rooms: user
       });
    } else {
      // Handle the case when responseData is not an array
      console.error('API response is not an array:', user);
      this.setState({ 
        rooms: []
       });
    }
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      this.props.history.push('/signin');
  }
  }
};

fetchSeatData = async (todayDateInput) => {
  const token = localStorage.getItem('token'); 
    const config = {
      headers: { Authorization:` ${token}`}
    };
    const formattedDate = todayDateInput.split('-').reverse().join('-');
  try {
     const response = await axios.get(`${var_api}/api/seat-status/get/${formattedDate}`, config);
    const user =response.data;

     if (Array.isArray(user)) {
      this.setState({ 
        seats: user
       });
    } else {
      // Handle the case when responseData is not an array
      console.error('API response is not an array:', user);
      this.setState({ 
        seats: []
       });
    }
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      this.props.history.push('/signin');
  }
  }
};

//open to the view room eye modal
handleOpenEyeOrderDetail = (order, room_name) => {
  this.setState({isOrderConfirmation:true, viewService:order, selectedRoomName: room_name});
  console.log("view order", order)
}

//close to the view room eye modal
handleCloseOrderConfirmation = () => {
  this.setState({isOrderConfirmation:false});
}

handleDateChange = (event) => {
  this.setState({ todayDateInput: event.target.value });
  console.log("dchange the date", this.state.todayDateInput, event.target.value);
  this.fetchRoomData(event.target.value);
  this.fetchSeatData(event.target.value);
};


formatDate = (date) => {
  if (!date) {
      return '';
  }
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
};



// computeSummaryCounts = (data) => {
//   let counts = { total: 0, upcoming: 0, inProgress: 0, closed: 0 };
  
//   counts.total = data.length;
  
//   data.forEach(item => {
//     if (item.order_status == '0') {
//       counts.upcoming += 1;
//     } else if (item.order_status == '1') {
//       counts.inProgress += 1;
//     } else if (item.order_status == '2') {
//       counts.closed += 1;
//     }
//   });

//   return counts;
// };


computeSummaryCounts = (data) => {
  // Filter out orders where services.length === 0
  data = data.filter(order => order.services.length !== 0);

  let counts = { total: 0, upcoming: 0, inProgress: 0, closed: 0 };

  counts.total = data.length;
  console.log("dataa", data);
  data.forEach(item => {
    if (item.order_status == '0') {
      counts.upcoming += 1;
    } else if (item.order_status == '1') {
      counts.inProgress += 1;
    } else if (item.order_status == '2') {
      counts.closed += 1;
    }
  });

  return counts;
};



fetchData = async () => {
  this.setState({ isHistoryLoader: true});
  const formattedDate = this.formatDate(this.state.selectedDate); // Convert date to DD-MM-YYYY
  const token = localStorage.getItem('token');
  const headers = {
      Authorization: `${token}`,
  };

  try {
      const response = await axios.get(`${var_api}/api/service-history/${formattedDate}`, { headers });
      const cateNames = response.data;

      console.log("categories", cateNames);
      const counts = this.computeSummaryCounts(cateNames);
      this.setState({ 
        allServicesHistory: cateNames,
        servicesHistory: this.filterData(cateNames, this.state.selectedOption),
        summaryCounts: counts, // Store counts in state
        isHistoryLoader: false
      });
  } catch (error) {
      console.log('Error fetching data:', error);
      this.setState({ isHistoryLoader: false});
      if (error.response && error.response.status === 401) {
        this.props.history.push('/signin');
    }
  }
};


fetchSummaryData = async () => {
  const formattedDate = this.formatDate(this.state.selectedDate); // Convert date to DD-MM-YYYY
  const token = localStorage.getItem('token');
  const headers = {
      Authorization: `${token}`,
  };

  try {
      const response = await axios.get(`${var_api}/api/service-history-summary/${formattedDate}/${this.state.selectedOption}`, { headers });
      const cateNames = response.data;

      console.log("categories", cateNames);
      this.setState({ servicesSummaryHistory: cateNames });
  } catch (error) {
      console.log('Error fetching data:', error);
      if (error.response && error.response.status === 401) {
        this.props.history.push('/signin');
    }
  }
};


handleDateHistoryChange = (event) => {
  const newDate = event.target.value;
  console.log("selectdate",newDate);
  this.setState({ selectedDate: newDate }, () => {
    this.fetchData();
    // this.fetchSummaryData();
  });
};

filterData = (data, selectedOption) => {
  if (selectedOption == '3') { // '3' is for 'All'
    return data;
  }
  return data.filter(item => item.order_status == selectedOption);
};

handleOptionChange = (option) => {
  // this.setState({ selectedOption: option.value }, () => {
  //   this.fetchData();
  //   this.fetchSummaryData();
  // });
  this.setState({ 
    selectedOption: option.value,
    servicesHistory: this.filterData(this.state.allServicesHistory, option.value)
  });
  console.log("filter",this.filterData(this.state.allServicesHistory, option.value))
};


//room chekcing
fetchRoomChecking= async(from_time, to_time, index)=> {
  const formattedDate = this.formatDate(this.state.selectedDate); // Convert date to DD-MM-YYYY
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `${token}`,
};
    try {
      const response = await axios.get(`${var_api}/api/checking-room-free/${from_time}/${to_time}/${this.state.selectedRoomId}/${formattedDate}`, { headers });
      const data = response.data;
      console.log(' fetching data:', data);
      if (!data.isFree) {
        alert(`This room is already in use from ${from_time} to ${to_time}`);
        this.setState((prevState) => {
          const updatedServiceCart = [...prevState.serviceCart];
          updatedServiceCart[index].from_time = '';
          updatedServiceCart[index].to_time = '';
          return { serviceCart: updatedServiceCart, isFree: data.isFree, services: data.services };
        });
      } else {
        this.setState({ isFree: data.isFree, services: data.services });
      }
      
    } catch (error) {
      console.log('Error fetching data:', error);
      if (error.response && error.response.status === 401) {
        this.props.history.push('/signin');
    }
      
    }
}


//seat chekcing
fetchSeatChecking= async(from_time, to_time, index)=> {
  const token = localStorage.getItem('token');
  const formattedDate = this.formatDate(this.state.selectedDate); // Convert date to DD-MM-YYYY
  const headers = {
    Authorization: `${token}`,
};
    try {
      const response = await axios.get(`${var_api}/api/checking-seat-free/${from_time}/${to_time}/${this.state.selectedSeatId}/${formattedDate}`, { headers });
      const data = response.data;
      console.log(' fetching data:', data);
      if (!data.isFree) {
        alert(`This seat is already in use from ${from_time} to ${to_time}`);
        this.setState((prevState) => {
          const updatedServiceCart = [...prevState.serviceCart];
          updatedServiceCart[index].from_time = '';
          updatedServiceCart[index].to_time = '';
          return { serviceCart: updatedServiceCart};
        });
      }
      
    } catch (error) {
      console.log('Error fetching data:', error);
      if (error.response && error.response.status === 401) {
        this.props.history.push('/signin');
    }
      
    }
}


//room chekcing
fetchEmployeeChecking= async(from_time, to_time,employee_id)=> {
  const token = localStorage.getItem('token');
  const formattedDate = this.formatDate(this.state.selectedDate); // Convert date to DD-MM-YYYY
  const headers = {
    Authorization: `${token}`,
};
    try {
      const response = await axios.get(`${var_api}/api/checking-employee-free/${from_time}/${to_time}/${employee_id}/${formattedDate}`, { headers });
      const data = response.data;
      this.setState({ empChecking: data})
      console.log(' fetching data:', data);
      if (!data.isFree) {
        alert(`This employee is already booked from ${from_time} to ${to_time}`);
      } else {
        this.setState({ empChecking: data });
      }
      console.log('Fetching data:', data);
      
    } catch (error) {
      console.log('Error fetching data:', error);
      if (error.response && error.response.status === 401) {
        this.props.history.push('/signin');
    }
      
    }
}


formatTimeTo12Hours(timeString) {
  if (!timeString) return '';
  const [hours, minutes] = timeString.split(':');
  let period = 'AM';
  let hour = parseInt(hours, 10);

  if (hour === 0) {
    hour = 12;
  } else if (hour === 12) {
    period = 'PM';
  } else if (hour > 12) {
    hour -= 12;
    period = 'PM';
  }

  return `${hour}:${minutes} ${period}`;
}


//onchange function for from_time when the post
handleTimeChange = (event,index) => {
  const { name, value } = event.target;
  const { checkedItems, serviceCart } = this.state;


   // Check if the checkbox for this index is checked
   if (!checkedItems[index]) {
    alert("Please check the checkbox before changing the time.");
    return;
  }


  const updatedServiceCart = [...serviceCart];
  updatedServiceCart[index][name] = value;

  // Calculate the "to_time"
  const fromTime = updatedServiceCart[index].from_time;
  const duration = updatedServiceCart[index].service_duration + updatedServiceCart[index].additionalDuration;
  if (fromTime && duration) {
    updatedServiceCart[index].to_time = this.calculateToTime(fromTime, duration);
  }

  this.setState({ serviceCart: updatedServiceCart }, () => {
    const { from_time, to_time } = this.state.serviceCart[index];
    const service = this.state.serviceCart[index];
    if (service.seat_id && service.type === 'seat') {
      this.validateAndFetchSeat(from_time, to_time, index);
    } else if (service.room_id && service.type === 'room') {
      this.validateAndFetch(from_time, to_time, index);
    }
  });

  
  // this.setState((prevState) => {
  //   const updatedServiceCart = [...prevState.serviceCart];
  //   updatedServiceCart[index][name] = value;
  //   return { serviceCart: updatedServiceCart };
  // }, () => {
  //   const { from_time, to_time } = this.state.serviceCart[index];
  //   const service = this.state.serviceCart[index];
  //   if (service.seat_id && service.type == 'seat') {
  //     this.validateAndFetchSeat(from_time, to_time, index);
  //   } else if (service.room_id && service.type == 'room') {
  //     this.validateAndFetch(from_time, to_time, index);
  //   }
  // });
  console.log("time", event.target.value, this.state.checkedItems);
};

handleSlotClick = (time, index) => {
  const { checkedItems, serviceCart } = this.state;

  // Check if the checkbox for this index is checked
  // if (!checkedItems[index]) {
  //   alert("Please check the checkbox before selecting a time slot.");
  //   return;
  // }

  // Ensure serviceCart[index] exists before accessing it
  // if (!serviceCart[index]) {
  //   console.error(`Service cart item at index ${index} is undefined.`);
  //   return;
  // }

  // Update the selected service's from_time
  const updatedServiceCart = [...serviceCart];
  updatedServiceCart[index] = {
    ...updatedServiceCart[index], // Spread existing data to avoid overwriting other fields
    from_time: time
  };

  // Calculate the to_time based on the duration
  const fromTime = updatedServiceCart[index].from_time;
  const duration = updatedServiceCart[index].service_duration + updatedServiceCart[index].additionalDuration;
  if (fromTime && duration) {
    updatedServiceCart[index].to_time = this.calculateToTime(fromTime, duration);
  }

  // Update state and set selected time
  this.setState({
    serviceCart: updatedServiceCart,
    selectedTime: time
  }, () => {
    const { from_time, to_time } = this.state.serviceCart[index];
    const service = this.state.serviceCart[index];
    if (service.seat_id && service.type === 'seat') {
      this.validateAndFetchSeat(from_time, to_time, index);
    } else if (service.room_id && service.type === 'room') {
      this.validateAndFetch(from_time, to_time, index);
    }
  });
};



generateTimeSlots = (time) => {
  const [hours, minutes] = time.split(':').map(Number);
  const slots = [];
  for (let i = 0; i < 4; i++) {
    const newMinutes = (minutes + i * 15) % 60;
    const newHours = hours + Math.floor((minutes + i * 15) / 60);
    const timeLabel = `${newHours}:${newMinutes.toString().padStart(2, '0')}`;
    slots.push(timeLabel);
  }
  return slots;
};

// Helper function to format time as 12-hour AM/PM format
formatTime(hour, minute) {
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const formattedHour = hour % 12 || 12;
  const formattedMinute = minute.toString().padStart(2, '0');
  return `${formattedHour}:${formattedMinute} ${ampm}`;
}

hoverSlot = (timeSlot) => {
  this.setState({ hoveredSlot: timeSlot });
};

// Handle mouse leave
leaveSlot = () => {
  this.setState({ hoveredSlot: null });
};

getTimeLabel = (baseTime, offset) => {
  const date = new Date(`1970-01-01T${baseTime}:00`);
  date.setMinutes(date.getMinutes() + offset);
  return date.toTimeString().slice(0, 5);
};

//onchange function for beautician when the post
handleBeauticianChange = (selectedOption, index) => {
  console.log("eee", selectedOption);
  this.setState(prevState => {
    const updatedServiceCart = prevState.serviceCart.map((service, idx) => {
        if (index === idx) {
            return {
                ...service,
                employee_id: selectedOption.value,
                employee_name: selectedOption.label
            };
        }
        return service;
    });
    const from_time = updatedServiceCart[index].from_time;
    const to_time = updatedServiceCart[index].to_time;

    return { beautician: selectedOption, serviceCart: updatedServiceCart };
}, () => {
  const { from_time, to_time, seat_id, room_id, type } = this.state.serviceCart[index];
  if (seat_id) {
    this.validateAndFetchSeat(from_time, to_time, index);
  } else if (room_id) {
    this.validateAndFetch(from_time, to_time, index);
  }
});
console.log("selectedOption", selectedOption);
};


    
validateAndFetch = (from_time, to_time, index) => {
  const { beautician } = this.state;
  console.log("validation",from_time,to_time)

  if (from_time && to_time && from_time >= to_time) {
    this.setState({ validationError: 'From Time must be earlier than To Time' });
    console.log("checking", from_time >= to_time);
  } else {
    this.setState({ validationError: '' });
    this.fetchRoomChecking(from_time, to_time, index);
    if (this.state.serviceCart[index].employee_id && from_time && to_time) {
      this.fetchEmployeeChecking(from_time, to_time, this.state.serviceCart[index].employee_id);
      console.log("emp is there", this.state.serviceCart[index].employee_id);
    }
  }
};


validateAndFetchSeat = (from_time, to_time, index) => {
  console.log("validation",from_time,to_time)
  if (from_time && to_time && from_time >= to_time) {
    this.setState({ validationError: 'From Time must be earlier than To Time' });
    console.log("checking", from_time >= to_time);
  } else {
    this.setState({ validationError: '' });
    this.fetchSeatChecking(from_time, to_time, index);
    if (this.state.serviceCart[index].employee_id && from_time && to_time) {
      this.fetchEmployeeChecking(from_time, to_time, this.state.serviceCart[index].employee_id);
      console.log("emp is there", this.state.serviceCart[index].employee_id);
    }
  }
};


//fetch beauticians
fetchBeauticians = async()=> {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `${token}`,
};
    try {
      const response = await axios.get(`${var_api}/api/employee/get-active-employees`, { headers });
      const data = response.data;
      console.log(' fetching data:', data);
      const beauticians = data.map(beautician => ({
        value: beautician.id,
        label: beautician.name
      }));
      this.setState({ beauticians });
      
    } catch (error) {
      console.log('Error fetching data:', error);
      if (error.response && error.response.status === 401) {
        this.props.history.push('/signin');
    }
      
    }
} 


// Function to convert minutes to hours and minutes
// convertMinutesToHours = (minutes) => {
//   // console.log("m", minutes)
//   if (!minutes && minutes == 0) return "0h 0m"; 
//   const hours = Math.floor(minutes / 60);
//   const remainingMinutes = minutes % 60;
//   if (hours > 0) {
//     return `${hours} hrs ${remainingMinutes} mins`;
//   } else {
//     return `${remainingMinutes} mins`;
//   }
// };
convertMinutesToHours = (minutes) => {
  // console.log("m", minutes)
  if (!minutes && minutes == 0) return "0h 0m"; 
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const hourLabel = hours === 1 ? 'hr' : 'hrs'; // Handle singular/plural for hours
  const minuteLabel = remainingMinutes === 1 ? 'min' : 'mins'; 
  if (hours > 0) {
    return `${hours} ${hourLabel} ${remainingMinutes} ${minuteLabel}`;
  } else {
    return `${remainingMinutes} ${minuteLabel}`;
  }
};

// Function to calculate the "to_time" based on "from_time" and "duration"
calculateToTime = (fromTime, duration) => {
  const [hours, minutes] = fromTime.split(':').map(Number);
  const totalMinutes = hours * 60 + minutes + duration;
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMinutes = totalMinutes % 60;
  return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
};


//open the update modal for time and beautician
handleOpenOrderEdit = (order) => {
  this.setState({isOpenOrderEdit:true, updatedOrder: order, additionalCostUpdate: order.additional_cost, additionalDurationUpdate: order.additional_duration})
  console.log('updated order', order, this.state.updatedOrder)
}

//close the update modal for time and beautician
handleCloseOrderEdit = () => {
  this.setState({isOpenOrderEdit:false})
}


//onchange function for from_time when the put
handleTimeChangeUpdate = async (event) => {
  const { name, value } = event.target;
  const { service_duration } = this.state.updatedOrder;
  const { updatedOrder , additionalDurationUpdate} = this.state;
  const updatedOrderCopy = { ...updatedOrder, [name]: value };

  if (name === 'start_time') {
    // Extract hours, minutes, and seconds from the start_time
    const [startHours, startMinutes, startSeconds] = value.split(':').map(Number);
     // Calculate the total duration in minutes
     const totalDuration = service_duration + (this.state.additionalCheckedUpdate ? additionalDurationUpdate : 0);

    // Calculate the total duration in minutes and seconds
    const durationHours = Math.floor(service_duration / 60);
    const durationMinutes = service_duration % 60;

    // Calculate the new time by adding duration to start time
    let endHours = startHours + durationHours;
    let endMinutes = startMinutes + durationMinutes;
    let endSeconds = startSeconds || 0;

    // Handle overflow of minutes to hours
    if (endMinutes >= 60) {
      endHours += Math.floor(endMinutes / 60);
      endMinutes = endMinutes % 60;
    }

   // Handle seconds correctly
   endSeconds = (startSeconds || 0).toString().padStart(2, '0');

   // Format end time to ensure two digits for hours, minutes, and seconds
   const formattedEndHours = endHours.toString().padStart(2, '0');
   const formattedEndMinutes = endMinutes.toString().padStart(2, '0');

    // Set the end_time in updatedOrder
    updatedOrderCopy.end_time = `${formattedEndHours}:${formattedEndMinutes}:${endSeconds}`;
  }

  // Update state with the modified order time
  this.setState({ updatedOrder: updatedOrderCopy });

  if(updatedOrderCopy.type === 'seat'){
    // Call fetchSeatCheckingUpdate to check seat availability
  await this.fetchSeatCheckingUpdate(updatedOrderCopy.start_time, updatedOrderCopy.end_time, updatedOrderCopy.seat_id, updatedOrderCopy.id);
  }else{
     // Call fetchSeatCheckingUpdate to check seat availability
  await this.fetchRoomCheckingUpdate(updatedOrderCopy.start_time, updatedOrderCopy.end_time, updatedOrderCopy.room_id, updatedOrderCopy.id);

  }
}


//onchange function for beautician when the put
handleBeauticianChangeUpdate = (selectedOption) => {
  console.log('Selected beautician:', selectedOption);
  const updatedOrder = {
    ...this.state.updatedOrder,
    employee_id: selectedOption.value,
    beautician: selectedOption.label,
  };
  this.setState({ updatedOrder }, () => {
    console.log('Updated order:', this.state.updatedOrder);
  });
};


//seat chekcing while put
fetchSeatCheckingUpdate = async (fromTime, toTime, seatId, id) => {
  const { selectedDate} = this.state;
  const token = localStorage.getItem('token');
  const formattedDate = this.formatDate(selectedDate); // Convert date to DD-MM-YYYY

  const headers = {
    Authorization: token,
  };

  try {
    const response = await axios.get(`${var_api}/api/checking-seat-free-put/${fromTime}/${toTime}/${seatId}/${formattedDate}/${id}`, { headers });
    const data = response.data;
    console.log('Fetching data:', data);

    if (!data.isFree) {
      alert(`This seat is already in use from ${fromTime} to ${toTime}`);
      // Clear the entered from_time
      const updatedOrderCopy = { ...this.state.updatedOrder };
      updatedOrderCopy.start_time = ''; // Reset start_time
      this.setState({ updatedOrder: updatedOrderCopy });
    }
  } catch (error) {
    console.log('Error fetching data:', error);
    if (error.response && error.response.status === 401) {
      this.props.history.push('/signin');
  }
  }
}


//seat chekcing while put
fetchRoomCheckingUpdate = async (fromTime, toTime, roomId, id) => {
  const { selectedDate} = this.state;
  const token = localStorage.getItem('token');
  const formattedDate = this.formatDate(selectedDate); // Convert date to DD-MM-YYYY

  const headers = {
    Authorization: token,
  };

  try {
    const response = await axios.get(`${var_api}/api/checking-room-free-put/${fromTime}/${toTime}/${roomId}/${formattedDate}/${id}`, { headers });
    const data = response.data;
    console.log('Fetching data:', data);

    if (!data.isFree) {
      alert(`This room is already in use from ${fromTime} to ${toTime}`);
      // Clear the entered from_time
      const updatedOrderCopy = { ...this.state.updatedOrder };
      updatedOrderCopy.start_time = ''; // Reset start_time
      this.setState({ updatedOrder: updatedOrderCopy });
    }
  } catch (error) {
    console.log('Error fetching data:', error);
    if (error.response && error.response.status === 401) {
      this.props.history.push('/signin');
  }
  }
}

//onchange function for check box
handleAdditionalCheckboxChangeUpdate = (event) => {
  const isChecked = event.target.checked;
  this.setState({ additionalCheckedUpdate: isChecked });
  if (!isChecked) {
    const updatedOrder = { ...this.state.updatedOrder };
    updatedOrder.additionalCostUpdate = 0;
    updatedOrder.additionalDurationUpdate = 0;

    // Recalculate the end_time without the additional duration
    if (updatedOrder.start_time) {
      const duration = updatedOrder.service_duration; // Use original service duration
      updatedOrder.end_time = this.calculateToTime(updatedOrder.start_time, duration);
    }
    this.setState({
        additionalCostUpdate: 0,
        additionalDurationUpdate: 0,
        updatedOrder
    });
}
};


//onchange funciton for additional  cost update
handleAdditionalCostChangeUpdate = (event) => {
  const value = event.target.value
  this.setState({ additionalCostUpdate: value.trim() === '' ? 0 : parseFloat(value)  });
};


//onchange function for additional duration update
handleAdditionalDurationChangeUpdate = (event) => {
  const value = event.target.value;
  const additionalDuration = value.trim() === '' ? 0 : parseInt(value);
  this.setState({ additionalDurationUpdate: additionalDuration }, () => {
    const { updatedOrder } = this.state;
  const additionalDuration = this.state.additionalCheckedUpdate ? this.state.additionalDurationUpdate : 0;
  const totalDuration = parseInt(updatedOrder.service_duration) + parseInt(additionalDuration);

  if (updatedOrder && updatedOrder.start_time) {
    const [startHours, startMinutes] = updatedOrder.start_time.split(':').map(Number);

    // Calculate the total duration in minutes
    const durationHours = Math.floor(totalDuration / 60);
    const durationMinutes = totalDuration % 60;

    // Calculate the new end time
    let endHours = startHours + durationHours;
    let endMinutes = startMinutes + durationMinutes;

    // Handle overflow of minutes to hours
    if (endMinutes >= 60) {
      endHours += Math.floor(endMinutes / 60);
      endMinutes = endMinutes % 60;
    }

    // Format end time to ensure two digits for hours and minutes
    const formattedEndHours = endHours.toString().padStart(2, '0');
    const formattedEndMinutes = endMinutes.toString().padStart(2, '0');

    // Set the end_time in updatedOrder
    const updatedOrderCopy = { ...updatedOrder, end_time: `${formattedEndHours}:${formattedEndMinutes}` };

    // Update state with the modified order time
    this.setState({ updatedOrder: updatedOrderCopy });
  }
  });
};



//put method for time and beauticain for seat
handleSubmitUpdate = async () => {
  const { updatedOrder, additionalCheckedUpdate, additionalCostUpdate, additionalDurationUpdate } = this.state;
  console.log('before put', updatedOrder);
  this.setState({ isLoader:true});
  const serviceId = updatedOrder.id; // Use the appropriate ID
  const token = localStorage.getItem('token');
  const data = {
    seat_start_time: updatedOrder.start_time,
    seat_end_time: updatedOrder.end_time,
    employee_id: updatedOrder.employee_id,
    employee_name: updatedOrder.beautician,
    service_cost:  updatedOrder.service_cost,
    service_duration: updatedOrder. service_duration,
    additional_cost: additionalCostUpdate,
    additional_duration: additionalDurationUpdate
  };

  try {
    const response = await axios.put(`${var_api}/api/seat_service/put/${serviceId}`, data, {
      headers: {
        Authorization: token
      }
    });
    this.fetchData();
    this.setState({ isOpenOrderEdit: false, additionalCheckedUpdate: false, additionalCostUpdate: 0, additionalDurationUpdate: 0});
    console.log('Service order updated successfully', response.data);
  } catch (error) {
    console.error('Error updating service order:', error);
    if (error.response && error.response.status === 401) {
      this.props.history.push('/signin');
  }
  }finally{
    this.setState({isLoader: false})
   
  }
};


//put method for time and beauticain for room
handleSubmitUpdateroom = async () => {
  const { updatedOrder, additionalCheckedUpdate, additionalCostUpdate, additionalDurationUpdate } = this.state;
  console.log('before put', updatedOrder);
  this.setState({ isLoader:true});
  const serviceId = updatedOrder.id; // Use the appropriate ID
  const token = localStorage.getItem('token');
  const data = {
    room_start_time: updatedOrder.start_time,
    room_end_time: updatedOrder.end_time,
    employee_id: updatedOrder.employee_id,
    employee_name: updatedOrder.beautician,
    service_cost:  updatedOrder.service_cost,
    service_duration: updatedOrder. service_duration,
    additional_cost: additionalCostUpdate,
    additional_duration: additionalDurationUpdate
  };

  try {
    const response = await axios.put(`${var_api}/api/room_service/put/${serviceId}`, data, {
      headers: {
        Authorization: token
      }
    });
    this.fetchData();
    this.setState({ isOpenOrderEdit: false, additionalCheckedUpdate: false, additionalCostUpdate: 0, additionalDurationUpdate: 0});
    console.log('Service order updated successfully', response.data);
  } catch (error) {
    console.error('Error updating service order:', error);
    if (error.response && error.response.status === 401) {
      this.props.history.push('/signin');
  }
  }finally{
    this.setState({isLoader: false})
  }
};

handleOpenDelete = (service, order) => {
  this.setState({ isDelete: true, deletedOrder:service, deletedBooking: order});
  console.log("deleted order",order, service)
}

handleCloseConfirmationDelete = () => {
  this.setState({isDelete: false});
}


handleDeleteRoom = async () => {
  const {deletedOrder, deletedBooking, remarks } = this.state;
  const token = localStorage.getItem('token');
  console.log("delete",deletedOrder);
  this.setState({isLoader: true});
  try {
      const postData = {
        order_id: deletedBooking.order_id,
        customer_name: deletedBooking.customer_name,
        customer_mobile: deletedBooking.customer_mobile,
        date: deletedBooking.order_date,
        employee_name: deletedOrder.beautician,
        employee_id: deletedOrder.employee_id,
        service_name: deletedOrder.service_name,
        service_id: deletedOrder.service_id,
        remarks: remarks,
      };

      const response = await axios.post(`${var_api}/api/cancellation-history/post`, postData, {
        headers: {
          Authorization: `${token}`, // Add your token here
        },
      });
      
      console.log(response.data);

       // After successfully posting, call the delete API
    const deleteResponse = await axios.delete(`${var_api}/api/room-services/delete/${deletedOrder.id}`, {
      headers: {
        Authorization: `${token}`, // Add your token here
      },
    });

    console.log("Delete response:", deleteResponse.data);
    
    alert('Cancellation successful');
    this.setState({isDelete: false, remarks: ''})
    this.fetchData();
  } catch (error) {
    console.error('Error posting cancellation:', error);
    alert('Error posting cancellation');
    if (error.response && error.response.status === 401) {
      this.props.history.push('/signin');
  }
  }finally{
    this.setState({isLoader: false});
  }
};


  // Function to handle onChange event and update remarks in state
  handleRemarksChange = (e) => {
    this.setState({ remarks: e.target.value });
  }


  handleDeleteSeat = async () => {
    const {deletedOrder, deletedBooking, remarks } = this.state;
    const token = localStorage.getItem('token');
    console.log("delete",deletedOrder);
    this.setState({isLoader: true});
    try {
        const postData = {
          order_id: deletedBooking.order_id,
          customer_name: deletedBooking.customer_name,
          customer_mobile: deletedBooking.customer_mobile,
          date: deletedBooking.order_date,
          employee_name: deletedOrder.beautician,
          employee_id: deletedOrder.employee_id || 3,
          service_name: deletedOrder.service_name,
          service_id: deletedOrder.service_id,
          remarks: remarks,
        };
  
        const response = await axios.post(`${var_api}/api/cancellation-history/post`, postData, {
          headers: {
            Authorization: `${token}`, // Add your token here
          },
        });
        
        console.log(response.data);
  
         // After successfully posting, call the delete API
      const deleteResponse = await axios.delete(`${var_api}/api/seat-services/delete/${deletedOrder.id}`, {
        headers: {
          Authorization: `${token}`, // Add your token here
        },
      });
  
      console.log("Delete response:", deleteResponse.data);
      
      alert('Cancellation successful');
      this.setState({isDelete: false, remarks: ''})
      this.fetchData();
    } catch (error) {
      console.error('Error posting cancellation:', error);
      alert('Error posting cancellation');
      if (error.response && error.response.status === 401) {
        this.props.history.push('/signin');
    }
    }finally{
      this.setState({isLoader: false});
    }
  };


  //add more service on history
  handleAddToMoreService(order) {
     // Validate and format the date of birth (dob) to yyyy-mm-dd
  let dobFormatted = '';
  if (order.dob) {
    const dateParts = order.dob.split('-');
    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Months are zero-based in JavaScript
      const year = parseInt(dateParts[2], 10);

      const date = new Date(year, month, day);
    if (!isNaN(date.getTime())) {
      dobFormatted = date.toISOString().slice(0, 10);
    } else {
      console.error('Invalid date of birth:', order.dob);
    }
  } else {
    console.error('Invalid date format:', order.dob);
  }
  }

    this.setState({ showService: false, ExistingOrder: order , customerName: order.customer_name, customerMobile: order.customer_mobile, dob: dobFormatted, serviceCart: []});
    console.log("existing data", order);
  }



  formatTime(timeString) {
    if (!timeString) return '';
    const [hours, minutes] = timeString.split(':');
    return `${hours}:${minutes}`;
  }


   //add more service on history
   handleCancelAddOrder() {
    this.setState({  ExistingOrder: null , customerName: '', customerMobile: '', serviceCart: [], dob:''});
  }


   handleAddSubmit=async(event) =>{
    event.preventDefault();
    if(this.state.serviceCart == 0){
      alert('Please select atleast one service!')
      return
    }
    this.setState({isLoader: true});

   const token = localStorage.getItem('token');
    const config = {
      headers: { Authorization: `${token}` }
    };

    const roomServices = this.state.serviceCart
  .filter(service => service.type === 'room')
  .map(service => ({
    confirm_booking_id: this.state.ExistingOrder.id,
    employee_id: service.employee_id, 
    employee_name: service.employee_name,
    room_id: service.room_id, 
    room_name: service.room_name, 
    service_id: service.id,
    service_name: service.service_name,
    service_cost: service.service_price,
    service_duration: parseInt(service.service_duration), // Assuming duration is in hours
    room_start_time:service.from_time,
    room_end_time: service.to_time,
    additional_cost: service.additionalPrice,
    additional_duration: parseInt(service.additionalDuration)
  }));

const seatServices = this.state.serviceCart
  .filter(service => service.type === 'seat')
  .map(service => ({
    confirm_booking_id: this.state.ExistingOrder.id,
    employee_id: service.employee_id,
    employee_name: service.employee_name,
    seat_id: service.seat_id,
    seat_name: service.seat_name, 
    service_id: service.id,
    service_name: service.service_name,
    service_cost: service.service_price,
    service_duration: parseInt(service.service_duration), // Assuming duration is in hours
    seat_start_time: service.from_time,
    seat_end_time: service.to_time,
    additional_cost: service.additionalPrice,
    additional_duration: parseInt(service.additionalDuration)
  }));


    try {
      const response = await axios.post(`${var_api}/api/service-add/post`, {
        room_services: roomServices,
        seat_services: seatServices
      }, config);

        // Show success message
        alert('Service Added successfully!');
        
        // Reset state
        this.setState({
          customerName: '',
          customerMobile: '',
          serviceCart: [],
          checkedItems: {},
          from_time: '',
          to_time: '',
          beautician: null,
          validationError: '',
          startDate: '', // Reset other fields as 
          selectedData:'',
          isCreditModal:false,
          isOpenAddInstant: false,
          showCanvas:false,
          ExistingOrder:null, 
          dob:""
        });
        this.fetchRoomData(this.state.todayDateInput);
        this.fetchSeatData(this.state.todayDateInput);
        this.fetchData();
        this.fetchSummaryData();
        this.setState({isLoader: false});

     console.log("success",response.data.message);
    } catch (error) {
      console.error('There was an error!', error);
      this.setState({isLoader: false});
      if (error.response && error.response.status === 401) {
        this.props.history.push('/signin');
    }
    }
  }


  //onchange for additional checkbox
  handleAdditionalCheckboxChange(event, index) {
    const checked = event.target.checked;
    const additionalChecked = { ...this.state.additionalChecked, [index]: checked };
    this.setState({ additionalChecked });

    const updatedServiceCart = this.state.serviceCart.map((service, i) => {
      if (i === index) {
        const updatedService = {
          ...service,
          additionalDuration: checked ? service.additionalDuration : 0,
          additionalPrice: checked ? service.additionalPrice : 0
        };
          // Recalculate the "to_time" if additional is unchecked
      if (!checked) {
        const fromTime = updatedService.from_time;
        const duration = updatedService.service_duration; // Only original duration
        if (fromTime && duration) {
          updatedService.to_time = this.calculateToTime(fromTime, duration);
        }
      }

      return updatedService;
      }
      return service;
    });
  
    this.setState({
      serviceCart: updatedServiceCart
    });
  }
  
 //onchange for additional cost
  handleAdditionalCostChange(event, index) {
    const value = event.target.value;
    const updatedServiceCart = this.state.serviceCart.map((service, i) => {
      if (i === index) {
          return {
              ...service,
              additionalPrice: value.trim() === '' ? 0 : parseFloat(value)
          };
      }
      return service;
  });
  this.setState({ serviceCart: updatedServiceCart });
    // const updatedServiceCart = this.state.serviceCart.map((service, i) => {
    //   if (i === index) {
    //     console.log("jesi",service.service_price)
    //     return {
    //       ...service,
    //       service_price:  value.trim() === '' ? service.service_price  : parseFloat(service.service_price) + parseFloat(value)
    //     };
    //   }
    //   return service;
    // });
    // console.log("cost",value,updatedServiceCart)
    // this.setState({ serviceCart: updatedServiceCart });
  }


   //onchange for additional duration
  handleAdditionalDurationChange(event, index) {
    const value = event.target.value;
    const updatedServiceCart = this.state.serviceCart.map((service, i) => {
      if (i === index) {
        const updatedService = {
          ...service,
          additionalDuration: value.trim() === '' ? 0 : parseFloat(value)
          
        };
        delete updatedService.from_time;
        delete updatedService.to_time;
        return updatedService;
      }
      return service;
    });
    console.log("duration",value,updatedServiceCart)
    this.setState({ serviceCart: updatedServiceCart });
  }
  

  // Handle toggle change
    handleToggleChange = () => {
        this.setState(prevState => ({
            imageStatus: !prevState.imageStatus
        }));
        console.log("imageSta", this.state.imageStatus);
    };

    // generateTimeSlots = () => {
    //   const slots = [];
    //   let start = new Date();
    //   start.setHours(9, 0, 0); // Start time at 9:00 AM
    //   const end = new Date();
    //   end.setHours(18, 0, 0); // End time at 6:00 PM
    
    //   while (start < end) {
    //     const timeString = start.toLocaleTimeString([], {
    //       hour: '2-digit',
    //       minute: '2-digit',
    //     });
    //     slots.push(timeString);
    //     start.setMinutes(start.getMinutes() + 30); // Increment by 30 minutes
    //   }
    
    //   return slots;
    // };
  
    getTimeInterval = async () => {
  this.setState({ isLoader: true });
  const formattedDate = this.formatDate(this.state.selectedDate); // Convert date to DD-MM-YYYY
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `${token}`,
  };
  
  console.log("timeList");
  try {
    const response = await axios.get(`${var_api}/api/booking-time-interval/${formattedDate}`, { headers });
    let timeList = response.data.time_intervals;
    
    console.log("timeList", timeList);
    
    // Only filter if the selected date is today
    const today = new Date();
    const selectedDate = new Date(this.state.selectedDate);
    
    if (selectedDate.toDateString() === today.toDateString()) {
      const now = new Date();
      const cutoffTime = new Date(now.getTime() - 2 * 60 * 60 * 1000); // Current time + 2 hours
      
      timeList = timeList.filter(timeSlot => {
        const [hours, minutes] = timeSlot.split(':').map(Number);
        const slotTime = new Date();
        slotTime.setHours(hours, minutes, 0, 0);
        
        return slotTime >= cutoffTime;
      });
    }
    
    // Update state with the filtered timeList
    this.setState({ timeList, isLoader: false });
  } catch (error) {
    console.log('Error fetching data:', error);
    this.setState({ isLoader: false });
    if (error.response && error.response.status === 401) {
      this.props.history.push('/signin');
    }
  }
};


    getTypeBooking = async () => {
      this.setState({ isLoader : true });
      
      const formattedDate = this.formatDate(this.state.selectedDate); // Convert date to DD-MM-YYYY
      const token = localStorage.getItem('token');
      const headers = {
        Authorization: `${token}`,
      };
    
      // Determine if the active tab is for rooms or seats
      const bookingType = this.state.activeTab === '1' ? 'room' : 'seat';
      const selectedId = this.state.activeTab === '1' ? this.state.selectedRoomId : this.state.selectedSeatId;
      console.log(this.state.selectedRoomId)
    
      try {
        // Dynamically adjust the API endpoint based on the selected tab (room or seat)
        const response = await axios.get(`${var_api}/api/get-type-booking/${formattedDate}/${bookingType}/${selectedId}`, { headers });
        const typeBooking = response.data;
    
        console.log("typebooking", typeBooking);
        this.setState({ typeBooking, isLoader: false });
    
      } catch (error) {
        console.log('Error fetching data:', error);
        this.setState({ isHistoryLoader: false });
        if (error.response && error.response.status === 401) {
          this.props.history.push('/signin');
        }
      }
    };

     // Helper function to check if a slot is booked
     isSlotBooked = (slot) => {
      const { typeBooking } = this.state;
    
      for (let booking of typeBooking) {
        for (let service of booking.services) {
          // Check if room_start_time and room_end_time are defined
          if (service.room_start_time && service.room_end_time) {
            const startTime = service.room_start_time.slice(0, 5);
            const endTime = service.room_end_time.slice(0, 5);
      
            // Adjust the logic based on your time slot format
            if (slot.includes(startTime) || slot.includes(endTime)) {
              return {
                booked: true,
                customer_name: booking.customer_name,
                order_id: booking.order_id,
                services: booking.services,
              };
            }
          }
          
          // If you need to check seat_start_time and seat_end_time as well, you can add similar checks here:
          if (service.seat_start_time && service.seat_end_time) {
            const seatStartTime = service.seat_start_time.slice(0, 5);
            const seatEndTime = service.seat_end_time.slice(0, 5);
    
            if (slot.includes(seatStartTime) || slot.includes(seatEndTime)) {
              return {
                booked: true,
                customer_name: booking.customer_name,
                order_id: booking.order_id,
                services: booking.services,
              };
            }
          }
        }
      }
      return { booked: false };
    };
    
    
    
    openModal = (bookingStatus) => {
      this.setState({
        selectedBooking: bookingStatus, // This will now contain services too
        isModalOpen: true, // Open the modal
      });
    };    
  
    // Close the modal
    closeModal = () => {
      this.setState({ isModalOpen: false, selectedBooking: null }); // Optionally reset selectedBooking
    };


    //gender onchange
    handleGenderChange = (e) => {
      this.setState({ gender: e.target.value });
    };


     // Function to handle email change
  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handleSelectGenderChange = (event) => {
    const selectedGender = event.target.value;
    this.setState({ selectedGender });
    
    // You can add additional logic here if needed,
    // like making an API call or filtering data based on gender
    console.log("Selected Gender: ", selectedGender);
  };


    render() {
      const { activeTab,isLogin,iscredit,updatedOrder, remarks } = this.state;
      const { customers, admin_Email } = this.state;
      const { selectedList } = this.state;
      const { orderNo,showTable } = this.state;
      const { shopName } = this.state;
      const { users } = this.state;
      const { foods } = this.state;
      const { orders } = this.state;
      const { searchQuery } = this.state;
      const { checkedCategories } = this.state;
      const { loading,editPaymodeOrder } = this.state;
      const { isPrinted,ItemCodeOptions,selectedItemCode,orderHistoryItems, token } = this.state;
      const { from_time, to_time, beautician, validationError , isFree, services, additionalChecked} = this.state;

      console.log("shop Id:",localStorage.getItem('shopId')); 
      // console.log("email Id:",this.state.selectedData.mail); 
      
     // Filter orders based on the search query
    const filteredOrders = orders.filter((order) => {
      const searchLower = searchQuery.toLowerCase();
      return (
        order.customer_name.toLowerCase().includes(searchLower) ||
        order.customer_phone.includes(searchQuery) ||
       ( order.order_no + '').includes(searchQuery) ||
        order.order_items.some((item) =>
          item.food_name.toLowerCase().includes(searchLower)
        )
      );
    });

    // Check if there are no matching results
const noResults = orderHistoryItems.length === 0;

const CartTotal = this.state.cartItems.reduce((accumulator, cartItem) => {
  return accumulator + cartItem.quantity * cartItem.food.price;
}, 0);


// Calculate the total amount from selectedAmounts
const modeTotal = this.state.selectedAmounts.reduce((accumulator, amount) => {
  return accumulator + amount;
}, 0);


const editModeTotal = this.state.editSelectedAmounts && this.state.editSelectedAmounts.reduce((sum, currentItem) => sum + currentItem.amount, 0)
     


 

   

    
//     const collectionName = 'jaya';
// const documentName = 'twenty'; // The document name you want to find

// // Create a query to search for the document by its name
// const q = query(collection(db, collectionName));

// // Execute the query and get the matching documents
// getDocs(q)
//   .then((querySnapshot) => {
//     let foundDocumentId = null;
//     querySnapshot.forEach((docSnapshot) => {
//       const documentData = docSnapshot.data();
//       if (documentData && docSnapshot.id === documentName) {
//         // Document with the given name found
//         foundDocumentId = docSnapshot.id;
//         console.log('Document ID:', foundDocumentId);
//         console.log('Document Data:', documentData);
//       }
//     });

//     if (foundDocumentId === null) {
//       console.log('No document found with the given name.');
//     }
//   })
//   .catch((error) => {
//     console.error('Error fetching documents:', error);
//   });


const { categories, selectedCategory, serviceCart } = this.state;

const subtotal = this.calculateSubtotal();

// // Filter services based on gender
// const filteredServices = this.state.serviceCart.filter(service => 
//   !this.state.gender || service.gender === this.state.gender
// );

// // Calculate the subtotal based on the filtered services
// const subgendertotal = filteredServices.reduce((total, service) => total + service.service_price, 0);


  return (
    
    <>
      {/* {this.state.isLoader && <Loader />} */}

<Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
      <Navbar.Brand href="#home">
        <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin:"3px 60px"}} />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
      <Nav className="mx-auto fw-bolder fs-5">
  <Nav.Link href="#home" style={{ color: "rgba(103, 120, 95)", marginRight: "30px" }}>Home</Nav.Link>

  <Nav.Link as={Link} to="/dashboard" style={{ color: "rgba(103, 120, 95)", marginRight: "30px" }}>
    Dashboard
  </Nav.Link>

  <NavDropdown title="Masters" id="basic-nav-dropdown" style={{ color: "black", marginRight: "30px" }}>
    <NavDropdown.Item onClick={this.routeserviceChange}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Services</NavDropdown.Item>
    <NavDropdown.Item onClick={this.routeRoomSeat}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Room & Seats</NavDropdown.Item>
    <NavDropdown.Item onClick={this.routeRole}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Role</NavDropdown.Item>
    <NavDropdown.Item onClick={this.routeEmployees}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Employee</NavDropdown.Item>
    <NavDropdown.Item onClick={this.routeAvailableDayTime}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Available Day Time</NavDropdown.Item>
    <NavDropdown.Item onClick={this.routeTaxMaster}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Tax</NavDropdown.Item>
    <NavDropdown.Item onClick={this.routeReminderMaster}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Reminder</NavDropdown.Item>
    <NavDropdown.Item onClick={this.routePhotoGalleryMaster}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Photo Gallery</NavDropdown.Item>
    <NavDropdown.Item onClick={this.routePackageMaster}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Package</NavDropdown.Item>
  </NavDropdown>

  <NavDropdown title="Reports" id="basic-nav-dropdown" style={{ color: "black", marginRight: "30px" }}>
    <NavDropdown.Item onClick={this.routeSbReports}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Service History</NavDropdown.Item>
    {/* Conditionally render Employee Log only for admins and managers */}
    {(this.userRole === 'Admin' || this.userRole === 'Manager') ? (
          <NavDropdown.Item onClick={this.routeAttendance}>
            <i className="bi bi-arrow-right" style={{ color: 'green' }}></i> {' '}
            Employee Log
          </NavDropdown.Item>
        ) : (
          <NavDropdown.Item onClick={() => { swal({
            title: 'Access Denied!',
            text: 'Only admins and managers can view the Employee Log.',
            icon: 'warning',
            button: 'OK',
            confirmButtonColor: 'rgba(103,120,95,1)',
          });}}>
            <i className="bi bi-arrow-right" style={{ color: 'green' }}></i> {' '}
            Employee Log
          </NavDropdown.Item>
        )}
    {/* <NavDropdown.Item onClick={this.routeAttendance}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Employee Log</NavDropdown.Item> */}
    <NavDropdown.Item onClick={this.routeCustomerDetails}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Customer Details</NavDropdown.Item>
    <NavDropdown.Item onClick={this.routeReports}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Reports</NavDropdown.Item>
  </NavDropdown>
  
  <NavDropdown title="More" id="basic-nav-dropdown" style={{ color: "black", marginRight: "30px" }}>
  <NavDropdown.Item onClick={this.routeRoomSeatStatus}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Room & Seat Status</NavDropdown.Item>
  <NavDropdown.Item onClick={this.routeCancellation}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Cancellation Status</NavDropdown.Item>
  <NavDropdown.Item onClick={this.routeEmployeeServices}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Employee Services</NavDropdown.Item>
  <NavDropdown.Item onClick={this.routeEmployeeSalary}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Employee Salary</NavDropdown.Item>
  <NavDropdown.Item onClick={this.routeShopSettings}><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Settings</NavDropdown.Item>
    {/* <NavDropdown.Item ><i class="bi bi-arrow-right" style={{ color: "green" }}></i> {" "}Hide Image
    
    </NavDropdown.Item> */}
  </NavDropdown>

                <Nav.Link href="#pricing" style={{ color: "black", marginLeft: "30px", border:"2px solid black", fontSize:"15px" }} onClick={this.handleOnclick}>Logout</Nav.Link>
                <div className="form-check form-switch" style={{ display: 'inline-block', marginLeft: '10px' }}>
                    <input 
                        className="form-check-input" 
                        type="checkbox" 
                        id="imageToggle" 
                        checked={this.state.imageStatus} 
                        onChange={this.handleToggleChange} 
                    />
                    <label className="form-check-label" htmlFor="imageToggle" style={{fontFamily:"sans-serif", fontSize:"16px"}}>
                        {/* {this.state.imageStatus ? 'On' : 'Off'} */}
                        Image Status
                    </label>
                </div>
                {/* http://sq.suyaptech.com/ */}
                <Nav.Link 
      href={`http://localhost:8080/?token=${encodeURIComponent(token)}&email=${encodeURIComponent(admin_Email)}`}
      // href={`http://sage-sq.suyaptech.com/?token=${encodeURIComponent(token)}&email=${encodeURIComponent(admin_Email)}`}
      style={{
        color: "white",
        marginLeft: "30px",
        border: "2px solid rgba(103,120,95,1)",
        fontSize: "15px",
        padding: "10px 20px",
        // borderRadius: "5px",
        backgroundColor: "rgba(103,120,95,1)",
        boxShadow: "0 0 5px rgba(103,120,95,1)",
        transition: "box-shadow 0.3s ease-in-out",
        animation: "glow 1.5s infinite alternate",
        cursor: "pointer",
      }}
      
    >
      Go To Pro
    </Nav.Link>

     {/* Gender Filter Dropdown */}
     <div style={{marginLeft: "15px" }}>
        <label htmlFor="genderFilter" style={{ marginRight: "2px", fontSize: "16px", fontWeight: "bold" }}>Gender:</label>
        <select
          style={{ width: "150px", fontSize: "15px", padding: "5px",  border: "2px solid rgba(103,120,95,1)", height: "40px" }}
          onChange={this.handleSelectGenderChange}
          value={this.state.selectedGender} // Add state for gender selection
        >
          <option value="All">All</option>
          <option value="Female">Female</option>
          <option value="Male">Male</option>
          <option value="Others">Others</option>
        </select>
      </div>
    
</Nav>
      </Navbar.Collapse>
    </Navbar>
      
    <div style={{zIndex:"1"}}>
      <Offcanvas show={this.state.showCanvas} onHide={this.handleCloseCanvas}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title><i class="bi bi-cart-check-fill"></i> Your cart</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
       
  <div>
  {/* <label className="mt-2 fw-bolder">Phone No </label>
  {this.state.mobileOptions.length > 0 ? (
  <Select
          inputId="mobile"
          placeholder={this.state.customerMobile}
          maxLength="10"
          required
          value={this.state.mobileOptions.find(option => option.label === this.state.customerMobile)}
          onChange={this.handleMobileChange}
          onInputChange={this.handleInputChange}
          options={this.state.mobileOptions}
          isDisabled={!!this.state.ExistingOrder} // Disable if there is an existing orde
          isClearable
        />
      ) : (
        <Input
          type="number"
          id="mobileInput"
          placeholder="Mobile No"
          maxLength="10"
          value={this.state.customerMobile}
          onChange={this.handleMobileTextChange} // Bind this method in constructor
          required
          disabled={!!this.state.ExistingOrder}
        />
      )} */}
   <label className="mt-2 fw-bolder">
          Phone No <span style={{ color: 'red' }}>*</span>
        </label>
        <CreatableSelect
          inputId="mobile"
          placeholder={this.state.customerMobile || 'Mobile No'}
          maxLength={10}
          required
          value={
            this.state.mobileOptions.find(
              (option) => option.label === this.state.customerMobile
            ) || { label: this.state.customerMobile, value: this.state.customerMobile }
          }
          onChange={this.handleMobileChange}
          onInputChange={(inputValue) => {
            if (/^\d{0,10}$/.test(inputValue)) {
              this.handleInputChange(inputValue);
            }
          }}
          options={this.state.mobileOptions}
          isSearchable
          isClearable
          isDisabled={!!this.state.ExistingOrder}
          noOptionsMessage={() => 'No mobile number found'}
          formatCreateLabel={(inputValue) => `Use "${inputValue}"`}
        />

      {/* {this.state.customerMobile} */}
  <label className="mt-2 fw-bolder">Customer Name<span style={{color:"red"}}>*</span> </label>
  {this.state.exStatus ?
    <Input
  type="text"
  id="name"
  placeholder="Name"
  required
  value={this.state.exStatus ? this.state.customerName : ""}
  onChange={this.handleNameChange}
  disabled={!this.state.exStatus || !!this.state.ExistingOrder}
/>
  :
  <Input
    type="text"
    id="name"
    placeholder="Name"
    required
    value={this.state.customerName}
    onChange={this.handleNameChange}
    disabled={!!this.state.ExistingOrder}
  />
}

<div className="d-flex align-items-center mt-2">
    <label className="fw-bolder">Gender<span style={{color:"red"}}>*</span> </label>
    <div className="ms-2">
      <Form.Check
        inline
        type="radio"
        label="Male"
        name="gender"
        id="male"
        value="Male"
        checked={this.state.gender === "Male"}
        onChange={this.handleGenderChange}
        disabled={!!this.state.ExistingOrder}
      />
      <Form.Check
        inline
        type="radio"
        label="Female"
        name="gender"
        id="female"
        value="Female"
        checked={this.state.gender === "Female"}
        onChange={this.handleGenderChange}
        disabled={!!this.state.ExistingOrder}
      />

<Form.Check
        inline
        type="radio"
        label="Others"
        name="gender"
        id="Others"
        value="Others"
        checked={this.state.gender === "Others"}
        onChange={this.handleGenderChange}
        disabled={!!this.state.ExistingOrder}
      />
    </div>
  </div>

  <label className="mt-2 fw-bolder">Email</label>
  <Input
    type="email"
    id="email"
    placeholder="Email"
    value={this.state.email}
    onChange={this.handleEmailChange}
    required
    disabled={!!this.state.ExistingOrder}
  />


<div key="checkbox" className="d-flex align-items-center mt-1">
          <Form.Check
            type="checkbox"
            id="check-api-checkbox-dob"
            onChange={this.handleCheckboxDobChange}
            checked={this.state.isDobChecked}  // Controlled by state
          />{" "}
          <Form.Check.Label htmlFor="check-api-checkbox-dob fw-bolder" style={{ fontSize: "13px", fontWeight: "bolder", marginLeft: "5px" }}>
            DOB
          </Form.Check.Label>
        </div>

        {this.state.isDobChecked && (
          <div>
            <label className="mt-2 fw-bolder">Date of Birth : {this.state.ExistingOrder ? this.state.ExistingOrder.dob : " "} </label>
            {
              this.state.ExistingOrder ? null : (
                <Input
                  type="date"
                  id="dob"
                  placeholder="Date of Birth"
                  value={this.state.dob}
                  onChange={this.handleDobChange}
                  required
                  disabled={!!this.state.ExistingOrder}
                />

              )
            }
          </div>
        )}

 </div>
 
<br/>
       
           <div>
            {
              serviceCart
              // .filter(service => !this.state.gender || service.gender === this.state.gender)
              .map((service, index)=>(

                <Card bg="light"  text="dark" key={index} style={{ width: 'auto', height:"auto", border:"none", borderBottom:"1px solid black", borderRadius:"0px" }} className="mb-2">
                <div className="row g-0">
                  <div className="col-md-4 p-3">
                     <Card.Img src={`${var_api}/${service.service_image}`} alt="Card image" /> 
                   
                  </div>
                  <div className="col-md-8">
                    <Card.Body>
                      <Card.Text>
                       <h6>{service.service_name} <span style={{float:"right"}}><i class="bi bi-x-circle-fill" onClick={() => this.handleRemoveFromCart(service.id)}></i></span></h6>
                       <h6>{this.convertMinutesToHours(service.service_duration)}</h6>
                       <h6 className="fw-bolder">{service.service_price} $</h6>
                      </Card.Text>
                    </Card.Body>
                  </div>
                </div>
              </Card>


              ))
            }
          
       </div>
       <h6 style={{fontSize:"15px", fontFamily:"Arial, Helvetica, sans-serif"}}><b style={{color:"rgba(103,120,95,1)"}}>Service Count:</b> {serviceCart.length}</h6>
       <h6 style={{fontSize:"20px", fontFamily:"fantasy"}}>Sub Total:   ${subtotal}</h6>
      <div className="text-center mt-5">
        {
          !this.state.ExistingOrder ? 
          <>
          <button type="button" class="btn btn-primary " onClick={this.handleGenerateOrderModal} style={{backgroundColor:"rgba(103,120,95,1)",borderColor:"rgba(103,120,95,1)", marginRight:"5px"}}>Book Service</button>
          <button type="button" class="btn btn-primary " onClick={this.handleGenerateOrderModalReset} style={{backgroundColor:"red",borderColor:"red"}}>Reset</button>
          </>
          : <>
          <button type="button" class="btn btn-primary" onClick={this.handleGenerateOrderModal} style={{backgroundColor:"rgba(103,120,95,1)",borderColor:"rgba(103,120,95,1)", marginRight:"5px"}}>Add Service</button>
          <button type="button" class="btn btn-danger" onClick={this.handleCancelAddOrder} >Cancel</button>
          </>
        }
     
      </div>
        </Offcanvas.Body>
      </Offcanvas>
     </div>
     <br/>
     <br/>
     <br/>
     <div>
        <div className="d-flex justify-content-center mt-5" >
          <Row xs={1} md={2} lg={3} xl={4} xxl={4} className="g-1">

            <Col>
              <Card
                style={{
                  maxWidth: "9rem",
                  height: "auto",
                  border: "2px solid black",
                  backgroundColor: selectedCategory === null ? "black" : "white",
                  padding: "0px",
                  borderRadius: "0px",
                  cursor: "pointer"
                }}
                onClick={() => this.handleCategoryClick(null)} // Reset selected category when "ALL" is clicked
              >
                <Card.Body>
                  <Card.Title
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      padding: "0px",
                      margin: "0px",
                      color: selectedCategory === null ? "white" : "black",
                    }}
                  >
                    ALL
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>

            {categories.map((category, idx) => (
              <Col key={category.id}>
                <Card
                  style={{
                    maxWidth: "9rem",
                    height: "auto",
                    border: "2px solid black",
                    backgroundColor:
                      selectedCategory === idx ? "black" : "white", // Check if the category is selected
                    padding: "0px",
                    borderRadius: "0px",
                    cursor: "pointer"
                  }}
                  onClick={() => this.handleCategoryClick(idx)} // Set selected category index
                >
                  <Card.Body>
                    <Card.Title
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        padding: "0px",
                        margin: "0px",
                        color: selectedCategory === idx ? "white" : "black" // Check if the category is selected
                      }}
                    >
                      {category.category_name.toUpperCase()}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
        <div className="d-flex justify-content-center mt-1">
  <Container>
    <Row xs={1} md={2} lg={3} xl={4} className="g-1">
      {/* Rendering subcategories */}
      {(selectedCategory === null
        ? categories.flatMap(category => category?.services || [])
        : categories[selectedCategory]?.services || []
      )
      .filter(subCategory => 
        this.state.selectedGender === "All" || subCategory.gender === this.state.selectedGender
      )
      .map(subCategory => {
        const isAdded = serviceCart.some(item => item.id === subCategory.id);
        return (
          <Col key={subCategory.id} className="mb-3">
            <Card
              style={{
                maxWidth: "15rem",
                height: "auto",
                border: "2px solid rgba(103,120,95,1)",
                backgroundColor: "rgba(50, 103, 19, 0.305)",
                padding: "10px",
                borderRadius: "0px"
              }}
            >
              {this.state.imageStatus && 
              <Card.Img
                variant="top"
                src={`${var_api}/${subCategory.service_image}`}
                style={{
                  maxWidth: "110px",
                  height: "100px",
                  display: "block",
                  margin: "0 auto",
                  borderRadius: "50%"
                }}
              />}
              <Card.Body>
                <Card.Title style={{ textAlign: "center" }}>
                  {subCategory.service_name}
                </Card.Title>
                <Card.Text>
                  <div className="text-center">
                    <p>{subCategory.description}</p>
                    <h6>
                      <b>{this.convertMinutesToHours(subCategory.service_duration)}</b>{" "}
                      <span><b>{subCategory.service_price} $</b></span>
                    </h6>
                    <Button
                      variant="dark"
                      onClick={() => this.handleAddToCart(subCategory)}
                      disabled={isAdded}
                    >
                      {isAdded ? "Added" : "Add to Cart"}
                    </Button>
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        );
      })}
    </Row>
  </Container>
</div>
      </div>
    <div >
    <Button 
  variant="light" 
  style={{
    border: "2px solid green",
    borderRadius: "50px",
    position: "fixed", // Set position to fixed
    left: "20px", // Adjust left position as needed
    bottom: "20px", // Adjust bottom position as needed
    zIndex: "999", // Set a high z-index to ensure the button is above other content
  }} 
  onClick={this.handleShowCanvas}
>
  <i className="bi bi-cart-fill fs-4" style={{ color: "green" }}></i>
  <span className="badge rounded-circle bg-dark" style={{ position: "absolute", top: "-5px", right: "-5px" }}>{serviceCart.length}</span>
</Button>
<Button 
  variant="light" 
  style={{
    border: "2px solid green",
    borderRadius: "50px",
    position: "fixed", // Set position to fixed
    right: "20px", // Adjust right position as needed
    bottom: "20px", // Adjust bottom position as needed
    zIndex: "999", // Set a high z-index to ensure the button is above other content
    margin: "10px", // Add margin as needed
  }} 
  onClick={this.handleShowServices}
>
  <i className="bi bi-stack fs-4" style={{ color: "green" }}></i>
  <span className="badge rounded-circle bg-dark" style={{ position: "absolute", top: "-5px", right: "-5px" }}>{this.state.servicesHistory.filter(order => order.services.length !== 0).length}</span>
</Button>

      
      <Offcanvas show={this.state.showService} onHide={this.handleCloseServices} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{textAlign:"center"}}>Service History - {this.state.servicesHistory.filter(order => order.services.length !== 0).length}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        {/* {this.state.isHistoryLoader && <Loader />} */}
        <h5 style={{color:"black",fontWeight:"bolder",letterSpacing:"1px"}} id="hefo" >
   <span >
     <button className="btn btn-danger text-white p-1" style={{fontSize:"15px"}}  onClick={this.handleOpenOrderSumModal}>Summary</button>
     </span> 
   </h5>
   
   
   <div style={{ display: 'flex', alignItems: 'center', gap:"10px" }}>
  
   <input
      type='date'
      name='date'
      style={{ border: "2px solid rgba(103,120,95,1)", borderRadius: "15px", height: "35px", padding: "10px" }}
      value={this.state.selectedDate}
      onChange={this.handleDateHistoryChange}
    />
                <Select
  options={this.state.labelCodeOptions}
  placeholder="Select Order"
  isSearchable={true}
  menuPlacement="bottom"
  className="sbcustomSelectFood"
  value={this.state.labelCodeOptions.find((option) => option.value === this.state.selectedOption)}
  onChange={this.handleOptionChange}
  styles={{
    menu: (provided) => ({
      ...provided,
      zIndex: 9999
    })
  }}
/>
       </div>
       <br/>
       {this.state.servicesHistory.length === 0 ? (
          <p style={{textAlign:"center", color:"red"}}>No orders available</p>
        ) : (
          this.state.servicesHistory.map((order, index) => (
             // Check if the services array in the current order is not empty
    order.services.length !== 0 && (
            <div style={{ marginTop: "-10px"}} key={index}>
              {/* <Bill order={service} ref={(el) => (this[`componentRef${index}`] = el)}  /> */}




              <div style={{backgroundColor:"rgba(74, 104, 57, 0.185)",padding:"15px",width:"390px",border:"3px ridge rgba(103,120,95,1)"}} ref={(el) => (this[`componentRef${index}`] = el)}>
        <div>
        <p style={{textAlign:"center",fontWeight:"bolder",textTransform:"uppercase",color:"rgba(103,120,95,1)",fontFamily:"sans-serif"}}>Sage Salon</p>
       
        <div className="m-0" style={{lineHeight: "15%",fontFamily:"sans-serif",margin:"0px"}}>
          <p  style={{textAlign:"center", fontWeight:"bold",fontSize:"12px"}}>#64 Serangoon Roa</p>
          <p  style={{textAlign:"center", fontWeight:"normal",fontSize:"12px",marginBottom:"10px"}}>Singapore 217969</p>
        </div>
     
       
        
      </div>
      <hr  style={{border:"1px dashed black",padding:"0px",margin:"0px"}}/>

     
        <h6 style={{fontWeight:"lighter",color:"black", fontSize:"14px"}} >Booking No:{" "}<b>{order.order_id}</b>
        <span style={{fontSize:"13px", float:"right",letterSpacing:"-1px"}}>{" "}{order.order_date}</span>
      
        </h6>
        <h6 style={{fontWeight:"lighter",color:"black", fontSize:"13px"}}>
        {/* <span style={{fontSize:"13px"}}> {
          order.order_status == 0 ? <span className="badge rounded-pill p-1" style={{backgroundColor:"lightskyblue"}}>Upcoming</span> : order.order_status == 1 ? <span className="badge rounded-pill bg-success p-1">Inprogress</span> : <span className="badge rounded-pill p-1" style={{backgroundColor:"purple"}}>Completed</span> 
          }
          </span> */}
          <span style={{fontSize:"13px", float:"right"}}>
          <button className="btn btn-success billHidden" style={{padding:"2px 4px", borderRadius:"8px", fontSize:"14px"}} onClick={()=>this.handleAddToMoreService(order)}><i class="bi bi-plus-circle"></i>{" "}Add</button>
          </span>
        </h6>
        {/* <h6 style={{fontWeight:"lighter",color:"black", fontSize:"13px"}} >From - To Time:{" "}<b>{order.services[0].start_time} - {order.services[order.services.length - 1].end_time}</b>
        </h6> */}
 <table style={{borderCollapse:"collapse",width:"100%",marginBottom:"10px"}}>

 <thead style={{borderTop:"1px solid rgba(103,120,95,1)",borderBottom:"1px solid rgba(103,120,95,1)",maxWidth:"100%"}}>
 <th style={{padding:"2px",color:"black"}}>Type</th>
 <th style={{padding:"2px",color:"black"}}>Beautician</th>
 <th style={{padding:"2px",color:"black"}}>Services</th>
 <th style={{padding:"2px",color:"black"}}>Time</th>
   <th style={{padding:"2px",color:"black"}}>Price</th>
   <th className="billHidden" style={{padding:"2px",color:"black"}}>status</th>
   <th style={{padding:"2px",color:"black"}}></th>
   {/* {(order.order_status == 0 || order.order_status == 1) && <th style={{padding:"2px",color:"black"}}>Action</th>} */}
 </thead>

 <tbody>
  {
    order.services.map((service,index)=>(
      <tr key={index}>
          <td style={{padding:"2px",color:"black",textAlign:"left",textTransform:"capitalize", fontSize:"12px"}}>{service.type === "room" ? service.room_name : service.seat_name}</td>
          <td style={{padding:"2px",color:"black",textAlign:"center", fontSize:"12px"}}>{service.beautician ? service.beautician : "-"}</td>
      <td style={{padding:"2px",color:"black",textAlign:"left",textTransform:"capitalize", fontSize:"12px"}}>{service.service_name}</td>
      <td style={{padding:"2px",color:"black",textAlign:"left",textTransform:"capitalize", fontSize:"12px"}}>{this.formatTime(service.start_time)}</td>
      <td style={{padding:"2px",color:"black",textAlign:"center", fontSize:"12px"}}>{service.service_cost + service.additional_cost} $</td>
      <td style={{padding:"2px",color:"black",textAlign:"center", fontSize:"12px"}} className="billHidden">{service.service_status == 0 ? <span className="badge rounded-pill p-1" style={{backgroundColor:"orange"}}>Upcoming</span> : 
                     service.service_status == 1 ? <span className="badge rounded-pill bg-success p-1">Inprogress</span> : <span className="badge rounded-pill p-1" style={{backgroundColor:"purple"}}>Completed</span>} </td>
      {(order.order_status === 0 || order.order_status === 1) && (
              <td style={{ padding: "2px", color: "black", textAlign: "center", fontSize: "10px" }}>
                <i className="bi bi-pencil-square billHidden"  style={{ color: "blue", fontSize: "18px" }} onClick={() => this.handleOpenOrderEdit(service)}></i>{' '}
                <i className="bi bi-trash-fill billHidden"  style={{ color: "red", fontSize: "18px" }} onClick={()=>this.handleOpenDelete(service, order)}></i>
              </td>
            )}
    </tr>

    ))

  }
   
  
   {/* <tr>
     <td style={{padding:"2px",color:"black",textAlign:"left",textTransform:"capitalize"}}>Skin1</td>
     <td style={{padding:"2px",color:"black",textAlign:"center"}}>10 SGD</td>
   </tr> */}
 
 </tbody>

</table>
<hr style={{border:"1px dashed black",position:"relative",top:"-15px",padding:"0px",marginBottom:"10px"}}/>
        <h6 style={{padding:"1px",color:"rgba(103,120,95,1)",textAlign:"center",fontWeight:"bolder",marginTop:"-20px",fontFamily:"monospace",marginBottom:"-2px"}}><b>Total Amount: {" "}
          {order.total_amount} </b> <span style={{fontSize:"17px"}}>$</span></h6>
          <hr style={{border:"1px dashed black",position:"relative",top:"-5px",padding:"0px",marginBottom:"10px"}}/>
          <h6 style={{fontWeight:"lighter",color:"black", fontSize:"13px",lineHeight:"2px"}} >Customer: {order.customer_name}
        <span style={{fontSize:"13px", float:"right",letterSpacing:"-1px"}}>Phone:{order.customer_mobile}</span>
        </h6>
      </div>
      <br/>






             <div style={{marginTop:"-40px"}}>
             <ReactToPrint
                  trigger={() => (
                    <div style={{ textAlign: 'center' }}>
                        <button className='btn-md btn-primary' id={`printButton${index}`} style={{ borderRadius: "5px", border: "none", padding: "7px", padding:"0px auto" }} ><i className="bi bi-printer-fill"></i></button>
                    </div>
                )}
                  content={() => this[`componentRef${index}`]}
                />
                
                <br/>
             </div>
             <br/>
            </div>
    )
          ))
        )}
        </Offcanvas.Body>
      </Offcanvas>
   
{/* </div> */}
   </div>






    
    <div >
   
 

<Modal
        show={this.state.show}
        onHide={this.handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Logout ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={this.handleCloseConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={this.handleModLogout}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>


      <Modal
        show={this.state.isDelete}
        onHide={this.handleCloseConfirmationDelete}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder"}}>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete <b style={{color:"red"}}>{this.state.deletedOrder && this.state.deletedOrder.service_name}</b> service?</h6> 
         </div>
         <Form.Group controlId="formBasicDescription" className="mb-2 single-line-form-group">
    <Form.Label className="form-label"><b>Remarks</b></Form.Label>
    <Form.Control type="text" placeholder="Enter remarks" className="form-control" value={remarks}
        onChange={this.handleRemarksChange}/>
  </Form.Group>

         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={this.handleCloseConfirmationDelete}>
            Close
          </Button>{' '} 
          {
          this.state.deletedOrder && this.state.deletedOrder.type === "room" ?  
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={this.handleDeleteRoom}>
          Confirm
        </Button> : 
        <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={this.handleDeleteSeat}>
            Confirm
          </Button>
        }
          
        </Modal.Body>
      </Modal>


      <Modal
        show={this.state.isOpenOrderEdit}
        onHide={this.handleCloseOrderEdit}
        backdrop="static"
        keyboard={false}
        size="lg" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ padding: "10px" }}></div>
          <div className="card" style={{ maxWidth: "35rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "10px", height: "auto", borderRadius: "15px" }}>
            <div className="card-body">
              {/* <div className="row">
                <div className="col">
                  <h6 style={{ color: "rgba(103, 120, 95)" }}>Booked By:{" "}<b style={{ color: "black" }}>{order.customer_name}</b> </h6>
                </div>
                <div className="col">
                  <h6 style={{ color: "rgba(103, 120, 95)" }}>Mobile: {" "}<b style={{ color: "black" }}>{order.customer_mobile}</b></h6>
                </div>
              </div> */}
              <hr />
              <div className="d-flex justify-content-center">
                <Accordion>
                  <Accordion.Item eventKey="0" style={{ border: "none" }}>
                    <Accordion.Header>
                      <div className="card" style={{ width: "21rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor: "rgba(103, 120, 95, 0.367)", borderRadius: "15px", margin: "8px" }}>
                        {updatedOrder && (
                          <div className="card-body">
                            <div className="row align-items-center">
                              <div className="col">
                                <span>{updatedOrder.service_name} <span style={{ float: "right", fontSize: "18px", color: "rgba(103, 120, 95)" }}></span></span>
                                <span style={{ color: "black", fontWeight: "bolder" }}>{  updatedOrder.service_cost + this.state.additionalCostUpdate} SGD</span>
                              </div>
                            </div>
                            <hr />
                            <h6 style={{ fontSize: "13px" }}><b>Duration:</b> { this.convertMinutesToHours(parseInt(updatedOrder.service_duration) + parseInt(this.state.additionalDurationUpdate))} <span style={{ fontSize: "13px", float: "right" }}><b>Beautician:</b> {updatedOrder.beautician} </span></h6>
                            <h6 style={{ fontSize: "13px" }}><b>Sitting type:</b> {updatedOrder.room_id ? "room" : updatedOrder.seat_id ? "Seat" : "-"} <span style={{ fontSize: "13px", float: "right" }}><b>{updatedOrder.room_id ? "room" : updatedOrder.seat_id ? "Seat" : " "} Name:</b> {updatedOrder.room_id ? (updatedOrder.room_name ? updatedOrder.room_name : "-") : (updatedOrder.seat_name ? updatedOrder.seat_name : "-")} </span></h6>
                            <h6 style={{ fontSize: "13px" }}><b> From Time:</b> {updatedOrder && updatedOrder.start_time ? this.formatTimeTo12Hours(updatedOrder.start_time) : "-"} <span style={{ fontSize: "13px", float: "right" }}><b> To Time:</b> {updatedOrder && updatedOrder.end_time ? this.formatTimeTo12Hours(updatedOrder.end_time) : "-"} </span></h6>
                            <Form>
     <div key="checkbox" className="d-flex align-items-center justify-content-between">
     <div className="d-flex align-items-center">
     <Form.Check
        type="checkbox"
        id="check-api-checkbox-additional-update"
        checked={this.state.additionalCheckedUpdate}
        onChange={this.handleAdditionalCheckboxChangeUpdate}
      />{" "}
                        <Form.Check.Label htmlFor="check-api-checkbox-additional-update" style={{ fontSize: "13px", fontWeight:"bolder", marginLeft:"5px" }}>
                          Additional
                        </Form.Check.Label>
                        </div>
                      </div>
                    </Form>
                    {this.state.additionalCheckedUpdate && (
    <div>
      <Form.Group controlId="additional-cost-update" className="mt-1">
        <Form.Label style={{ fontSize: "12px", fontWeight: "bold" }}>Additional Cost</Form.Label>
        <Form.Control
          type="number"
          placeholder="Enter additional cost"
          value={this.state.additionalCostUpdate}
          onChange={this.handleAdditionalCostChangeUpdate}
          min="0.1"
          step="0.1"
        />
      </Form.Group>
      <Form.Group controlId="additional-duration-update" className="mt-1">
        <Form.Label style={{ fontSize: "12px", fontWeight: "bold" }}>Additional Duration (in mins)</Form.Label>
        <Form.Control
          type="number"
          placeholder="Enter additional duration (minutes)"
          value={this.state.additionalDurationUpdate}
          onChange={this.handleAdditionalDurationChangeUpdate}
          min="0.1"
          step="0.1"
        />
      </Form.Group>
    </div>
  )}

                          </div>
                        )}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div style={{ display: 'flex', alignItems: 'center', gap: "10px", margin: "auto" }}>
                        <div>
                          <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>From Time </label>
                          <input
                            type="time"
                            name="start_time"
                            placeholder="select time"
                            value={updatedOrder && updatedOrder.start_time ? updatedOrder.start_time : ""}
                            onChange={this.handleTimeChangeUpdate}
                          />
                        </div>
                        <div>
                          <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>To Time </label>
                          <span>{updatedOrder && this.formatTimeTo12Hours(updatedOrder.end_time)}</span>
                        </div>
                        <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>Beautician </label>
                        <Select
                            options={this.state.beauticians}
                            // value={this.state.beauticians.find(option => option.value === updatedOrder && updatedOrder.employee_id)}
                            value={{label:updatedOrder && updatedOrder.beautician, value: updatedOrder && updatedOrder.employee_id}}
                            onChange={this.handleBeauticianChangeUpdate}
                            placeholder="Select Beautician"
                            isSearchable={true}
                            menuPlacement="bottom"
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                                position: 'absolute',
                              }),
                              container: (provided) => ({
                                ...provided,
                                width: '30%',
                              }),
                              control: (provided) => ({
                                ...provided,
                              }),
                            }}
                          />
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
              <br />
              <br />
              <div className="text-center">
                <button className="btn btn-success" style={{ color: "white", backgroundColor: "rgba(103, 120, 95)", borderColor: "rgba(103, 120, 95)", fontWeight: "normal" }} onClick={ updatedOrder && updatedOrder.type === "seat" ? this.handleSubmitUpdate : this.handleSubmitUpdateroom}>Update</button>
                <br />
                <br />
              </div>
            </div>
          </div>
          <br />
          <button className="btn btn-danger" style={{ fontWeight: "normal", float: "right" }} onClick={this.handleCloseOrderEdit}>Close</button>{' '}
          
        </Modal.Body>
      </Modal>



      
      
      <Modal
        show={this.state.isOpenSelectDate}
        onHide={this.handleCloseDateConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(6, 105, 16, 0.367)",padding:"12px"}}>
        <Modal.Title style={{fontSize:"19px", fontWeight:"bold"}}>Select Date Range</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            
            <div className="col">
              <label style={{color:"rgba(103, 120, 95)", fontFamily:"serif", fontWeight:"bolder"}}>Start Date:</label>
              <input type='date' name='date'  style={{border:"2px ridge rgba(103, 120, 95)",borderRadius:"15px",height:"35px",padding:"10px"}}
              placeholder='choose date' onChange={this.handleStartDateChange} value={this.formatDate(this.state.startDate)} />{" "}
            </div>
            <div className="col">
              <label style={{color:"rgba(103, 120, 95)", fontFamily:"serif", fontWeight:"bolder"}}>End Date:</label>
              <input type="date" name='date'  placeholder="choose date" onChange={this.handleEndDateChange} 
                 style={{border:"2px ridge rgba(103, 120, 95)",borderRadius:"15px",height:"35px",padding:"10px"}} value={this.formatDate(this.state.endDate)}
              />
            </div>
          </div>
     <br/>
         <div style={{textAlign:"center"}}>
         <Button variant="danger"  onClick={this.handleCloseDateConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{marginRight:"5px"}} onClick={this.handleSelectDateRange}>
            Ok
          </Button>
         </div>
        </Modal.Body>
      </Modal>


      <Modal
        show={this.state.isOpenOrderSummary}
        onHide={this.handleCloseSummaryConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(50, 103, 19, 0.305)",padding:"12px"}}>
        <Modal.Title style={{fontSize:"19px"}}> Today Booking Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <h5 style={{fontFamily:"rgba(103,120,95,1)",color:"rgba(103,120,95,1)",textAlign:"center"}}>
      Total Booking Count:{" "} 
      <span style={{textAlign:"center",color:"black",fontSize:"18px"}}>
        {this.state.summaryCounts.total}
      </span>
    </h5>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between",padding:"0px 20px"}}>
      <h5 style={{ fontFamily: "rgba(103,120,95,1)",  color: "rgba(103,120,95,1)" }}>
        Upcoming count: {" "}
        <span style={{ textAlign: "center", color: "black", fontSize: "18px" }}>
          {this.state.summaryCounts.upcoming}
        </span>
      </h5>

      <h5 style={{ fontFamily: "rgba(103,120,95,1)",  color: "rgba(103,120,95,1)" }}>
        Inprogress Count: {" "}
        <span style={{ textAlign: "center", color: "black", fontSize: "18px" }}>
          {this.state.summaryCounts.inProgress}
        </span>
      </h5>
      <h5 style={{ fontFamily: "rgba(103,120,95,1)",  color: "rgba(103,120,95,1)" }}>
        Closed count: {" "}
        <span style={{ textAlign: "center", color: "black", fontSize: "18px" }}>
          {this.state.summaryCounts.closed}
        </span>
      </h5>
</div>

     <br/>
         <div style={{textAlign:"center"}}>
         <Button variant="danger"  onClick={this.handleCloseSummaryConfirmation}>
            Close
          </Button>{' '} 
         
         </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={this.state.isNormalModal}
        onHide={this.handleCloseNormalConfirmation}
        backdrop="static"
        keyboard={false}
        size="xl" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
        <Modal.Title style={{fontSize:"19px", fontWeight:"bold"}}> Select Room</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div style={{margin:"auto",padding:"10px 20px 10px 20px"}}>
        <h5 style={{color:"rgba(103, 120, 95)",fontFamily:"serif",fontWeight:"bolder"}}>Rooms</h5>
        <div className="row" id="sbmafix" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', gap: '25px' }}>
    {/* {food.sub_food.map((item, index) => ( */}
        <div className="col mb-1 mt-1 ftco-animate"style={{ flex: '0 0 auto', maxWidth: '12rem' }}>
            <div className="card" id="sbeffe" style={{ width: '12rem', height:"auto", padding:"10px", marginTop:"-8px" }}>
              <img src={room1} alt='image' height="8rem" style={{ height:"8rem", marginTop:"1px" }} /> 
                <div style={{textAlign:"center", padding:"10px"}}>
                    <h6 className="card-title" style={{color:"rgba(103, 120, 95)", textTransform:"capitalize", fontSize:"18px"}}>Room1</h6>
                    <p style={{textAlign:"center", fontSize:"13px", margin:"3px 8px"}}>Desc: <b> A/C</b> </p>
                  
                      <button className="btn" style={{backgroundColor:"rgba(103, 120, 95)", color:"white",padding:"5px"}} 
                      onClick={() => this.addToCart()}
                      > Select</button> 
                </div>
            </div>
        </div>
        <div className="col mb-1 mt-1 ftco-animate"style={{ flex: '0 0 auto', maxWidth: '12rem' }}>
            <div className="card" id="sbeffe" style={{ width: '12rem', height:"auto", padding:"10px", marginTop:"-8px" }}>
              <img src={room2} alt='image' height="8rem" style={{ height:"8rem", marginTop:"1px" }} /> 
                <div style={{textAlign:"center", padding:"10px"}}>
                    <h6 className="card-title" style={{color:"rgba(103, 120, 95)", textTransform:"capitalize", fontSize:"18px"}}>Room2</h6>
                    <p style={{textAlign:"center", fontSize:"13px", margin:"3px 8px"}}>Desc: <b> Non - A/C</b> </p>
                
                      <button className="btn" style={{backgroundColor:"rgba(103, 120, 95)", color:"white",padding:"5px"}} 
                      onClick={() => this.addToCart()}
                      > Select</button> 
                    
                </div>
            </div>
        </div>
</div>
     
         <div style={{textAlign:"center", marginTop:"5px"}}>
        {" "}
         <Button variant="danger"  onClick={this.handleCloseNormalConfirmation}>
            Close
          </Button>{' '} 
         
         </div>
          
        </div>
        </Modal.Body>
      </Modal>


      


      <Modal
        show={this.state.isNormalCreditModal}
        onHide={this.handleCloseNormalCreditConfirmation}
        backdrop="static"
        keyboard={false}
        size="lg" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
        <Modal.Title style={{fontSize:"19px", fontWeight:"bold"}}>Update Room1   <i class="bi bi-calendar"></i> 26-04-2024 <i class="bi bi-clock"></i> 11:00 AM </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div style={{padding:"10px"}}>
             

                  

            </div>

                  <div class="card" style={{ width: "30rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "10px", height: "auto",borderRadius:"15px" }} >
                  <div style={{ display: 'flex', alignItems: 'center', gap:"10px", margin:"auto" }}>
    <label style={{fontFamily:"serif",fontWeight:"bolder"}}>Select Beautician: </label>
    <Select
        options={[
            { value: 'Kalpana', label: 'Kalpana' },
            { value: 'Jennie', label: 'Jennie' },
            { value: 'Maria', label: 'Maria' },
            { value: 'Rani', label: 'Rani' },
            { value: 'Sheela', label: 'Sheela' }
        ]}
        placeholder="Select Beautician"
        onChange={this.handleOrderLabelSelectChange}
        isSearchable={true}
        menuPlacement="top"
        className="sbcustomSelectFood"
        styles={{ menu: (provided, state) => ({
            ...provided,
            zIndex: 9999 // Increase the z-index to ensure the dropdown is displayed above other elements
        }) }}
    />
   
</div>

                      <div class="card-body">
   
    <div className="row">
      <div className="col">
        <h6 style={{color:"rgba(103, 120, 95)"}}>Booked By:{" "}<b style={{color:"black"}}>vinoth</b> </h6>
      </div>
      <div className="col">
        <h6 style={{color:"rgba(103, 120, 95)"}}>Mobile: {" "}<b style={{color:"black"}}>9035678765</b></h6>
      </div>
    </div>
   <hr/>



<div class="card" style={{ width: "20rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor:"rgba(103, 120, 95, 0.367)",borderRadius:"15px" }} >
                 
                      <div class="card-body">
   <div className="row align-items-center">
        <div className="col-auto">
          <img src={basic} alt="Room" style={{ borderRadius: "50%", height: "50px", width: "50px" }} />
        </div>
        <div className="col">
          <span>Basic Facial <span style={{float:"right",fontSize:"18px",color:"rgba(103, 120, 95)"}}><i class="bi bi-trash"></i></span></span><br />
          <span style={{color:"black",fontWeight:"bolder"}}>12 SGD</span>

        </div>
      </div>
      </div>
      </div>
    <br/>
    <div className="text-center">
    <button className="btn btn-success" style={{color:"white", backgroundColor:"rgba(103, 120, 95)",borderColor:"rgba(103, 120, 95)"}} ><i class="bi bi-plus-circle"></i> Add Services</button>
    <br/>
    <br/>
      <button className="btn btn-success" > <i class="bi bi-pencil-square"></i> Update Booking</button>
      </div>
   
   
  </div>
 
</div>
<br/>


                
        </Modal.Body>
      </Modal>


      <Modal
        show={this.state.isCreditModal}
        onHide={this.handleCloseCreditConfirmation}
        backdrop="static"
        keyboard={false}
        size="xl" // Set size to large
        dialogClassName="customize-modal"
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"10px"}}>
        <Modal.Title style={{ fontSize: "19px", fontWeight: "bold" }}>
          <div className="d-flex align-items-center">
            <h6 className="mr-" style={{ whiteSpace: 'nowrap',fontWeight:"bolder" }}>Booking Date:</h6>{" "}
            <input
  type="date"
  className="form-control mr-2"
  id="floatingOpenTime"
  required
  value={this.state.todayDateInput}
  onChange={this.handleDateChange}
  min={new Date().toISOString().split("T")[0]} // Set min to today's date
/>
            <span style={{ whiteSpace: 'nowrap',marginLeft:"180px" }}>Booking - Room & Seat</span>
          </div>
        </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{padding:"5px 120px"}}>
       
          
        <div className="d-flex justify-content-center mt-2">
      <Nav tabs>
        <NavItem style={{ border: "1px solid black", borderRadius: "8px", marginRight: "10px" }}>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { this.toggleTab('1'); }}
            style={{ backgroundColor: activeTab === '1' ? 'rgba(50, 103, 19, 0.305)' : 'transparent', color: activeTab === '1' ? 'white' : 'black' }}
          >
            ROOMS
          </NavLink>
        </NavItem>
        <NavItem style={{ border: "1px solid black", borderRadius: "8px", marginRight: "10px" }}>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { this.toggleTab('2'); }}
            style={{ backgroundColor: activeTab === '2' ? 'rgba(50, 103, 19, 0.305)' : 'transparent', color: activeTab === '2' ? 'white' : 'black' }}
          >
            SEATS
          </NavLink>
        </NavItem>
      </Nav>
    </div>
<br/>
<br/>
<br/>
<br/>
<br/>


<TabContent activeTab={activeTab}>
        <TabPane tabId="1" style={{marginTop:"-75px"}}>
    <div className="calendar-container">
    <Table responsive borderless className="calendar-table">
  <thead>
    <tr>
      {this.state.rooms.map(room => (
        <th key={room.id}>
          <img
            src={`${var_api}/${room.room_image}`}
            alt={room.room_name}
            style={{ width: '50px', height: '50px', borderRadius: "50px" }}
          />
          {" "}{room.room_name} {" "}
          {
            room.room_status == 0 ? <span className="badge rounded-pill bg-danger" style={{ color: "white", fontWeight: "normal", fontSize: "15px" }} >
           Not Available
          </span> :   <span className="badge rounded-pill bg-success" style={{ color: "white", fontWeight: "normal", fontSize: "15px" }} onClick={() => this.handletoOpenConfirmRoom(room.id, room.room_name)}>
            <i className="bi bi-plus-circle"></i>{" "}
          </span>
          }
        
        </th>
      ))}
    </tr>
  </thead>
  <tbody>
    <tr>
      {this.state.rooms.map(room => (
        <td key={room.id}>
          {room.confirm_orders.length > 0 ? (
            room.confirm_orders.map((order, index) => (
              <div key={index} className="d-flex justify-content-center">
                <Card className="calendar-card" style={{ maxWidth: "12rem", height: "auto", 
               borderLeft: `${order.order_status === 0 ? '10px solid lightSkyBlue' : order.order_status === 1 ? '10px solid green' : order.order_status === 2 ? '10px solid purple' : 'none'}`,
                marginTop:"10px" }}>
                  <Card.Body>
                    <h6 style={{ float: "right" }} onClick={()=>this.handleOpenEyeOrderDetail(order, room.room_name)}>
                      <i className="bi bi-eye-fill" style={{ color: "rgba(103, 120, 95)" }}></i>
                    </h6>
                    <br />
                    <h6><b>Booking No: {order.order_id}</b></h6>
                    <p style={{fontSize:"12px"}}>From Time: <b>{order.services[0].room_start_time}</b><br/>
                    <span style={{fontSize:"12px",lineHeight:"5px"}}>To Time: <b>{order.services[order.services.length - 1].room_end_time}</b></span></p>
                  </Card.Body>
                </Card>
              </div>
            ))
          ) : (
            <div>No Orders</div>
          )}
        </td>
      ))}
    </tr>
  </tbody>
</Table>

        </div>
    
    
        </TabPane>



       <TabPane tabId="2" style={{marginTop:"-75px"}}>
            <div className="calendar-container">
            <Table responsive borderless className="calendar-table">
              <thead>
                <tr>
                  {this.state.seats.map(seat => (
        <th key={seat.id}>
          <img
            src={`${var_api}/${seat.seat_image}`}
            alt={seat.seat_name}
            style={{ width: '50px', height: '50px', borderRadius: "50px" }}
          />
          {" "}{seat.seat_name} {" "}
          {
            seat.seat_status == 0 ? <span className="badge rounded-pill bg-danger" style={{ color: "white", fontWeight: "normal", fontSize: "15px" }} >
            Not Available
           </span> :   <span className="badge rounded-pill bg-success" style={{ color: "white", fontWeight: "normal", fontSize: "15px" }} onClick={() => this.handletoOpenConfirmSeat(seat.id, seat.seat_name)}>
            <i className="bi bi-plus-circle"></i>{" "}
          </span>
          }
         
        </th>
      ))}
                </tr>
              </thead>
              <tbody>
                  <tr>
                  {this.state.seats.map(seat => (
                      <td key={seat.id}>
                        {seat.confirm_orders && seat.confirm_orders.length > 0 ? (
            seat.confirm_orders.map((order, index) => (
              <div key={index} className="d-flex justify-content-center">
                <Card className="calendar-card" style={{ maxWidth: "12rem", height: "auto", 
               borderLeft: `${order.order_status === 0 ? '10px solid lightSkyBlue' : order.order_status === 1 ? '10px solid green' : order.order_status === 2 ? '10px solid purple' : 'none'}`,
                marginTop:"10px" }}>
                  <Card.Body>
                    <h6 style={{ float: "right" }} onClick={()=>this.handleOpenEyeOrderDetail(order, seat.seat_name)}>
                      <i className="bi bi-eye-fill" style={{ color: "rgba(103, 120, 95)" }}></i>
                    </h6>
                    <br />
                    <h6><b>Booking No: {order.order_id}</b></h6>
                    <p style={{fontSize:"12px"}}>From Time: <b>{order.services[0] && order.services[0].seat_start_time}</b><br/>
                    <span style={{fontSize:"12px",lineHeight:"5px"}}>To Time: <b>{order.services.length > 0 ? order.services[order.services.length - 1].seat_end_time : 'N/A'}</b></span></p>
                  </Card.Body>
                </Card>
              </div>
            ))
          ) : (
            <div>No Orders</div>
          )}
                      </td>
                    ))}
                  </tr>
              </tbody>
            </Table>
          </div>
          </TabPane>
      </TabContent>

       
        </Modal.Body>
      </Modal>
      
      <Modal
  show={this.state.isOpenAddInstant}
  onHide={this.handleCloseInstantAdding}
  backdrop="static"
  keyboard={false}
  size="xl"
  style={{ borderRadius: '20px' }}
>
  <Modal.Header
    closeButton
    style={{
      backgroundColor: 'rgba(103, 120, 95, 0.367)',
      padding: '12px',
    }}
  >
    <Modal.Title
      style={{
        fontSize: '19px',
        fontWeight: 'bold',
        textAlign: 'center',
      }}
    >
      Confirm Booking -{' '}
      {this.state.activeTab === '1' ? 'Rooms' : 'Seats'}{' '}
      {this.state.selectedRoomName} {this.state.selectedSeatName}
      <i className="bi bi-calendar" style={{ marginRight: '5px' }}></i>
      {(() => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(this.state.todayDateInput).toLocaleDateString(
          undefined,
          options
        );
      })()}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="row"  style={{ justifyContent: 'center', marginTop: '20px' }}>
      {/* Existing Card */}
      <div
        className="col-12 col-md-6"
        style={{
          maxWidth: '35rem',
          margin: 'auto',
          border: '1px solid rgba(103, 120, 95)',
          padding: '10px',
          height: 'auto',
          borderRadius: '15px',
        }}
      >
        <div className="card-body">
          {/* Existing content of your card */}
          <div className="row">
            <div className="col">
              <h6 style={{ color: 'rgba(103, 120, 95)' }}>
                Customer Name:{' '}
                <b style={{ color: 'black' }}>
                  {this.state.customerName}
                </b>{' '}
              </h6>
            </div>
            <div className="col">
              <h6 style={{ color: 'rgba(103, 120, 95)' }}>
                Phone Number:{' '}
                <b style={{ color: 'black' }}>
                  {this.state.customerMobile}
                </b>
              </h6>
            </div>
          </div>
          <hr />
{
this.state.serviceCart.map((service, index)=>(

<div className="d-flex justify-content-center" key={index}>
<Form>
<div key="checkbox" className="mb-3">
<Form.Check
type="checkbox"
id={`check-api-checkbox-${index}`}
checked={this.state.checkedItems[index] || false}
onChange={event => this.handleCheckboxChangeService(event, index, service)}
className="custom-checkbox"
/>
</div>
</Form>



<Accordion>
<Accordion.Item eventKey="0" style={{border:"none"}}>
<Accordion.Header>

<div class="card" style={{ width: "21rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor:"rgba(103, 120, 95, 0.367)",borderRadius:"15px", margin:"8px" }} >
         
         <div class="card-body">
<div className="row align-items-center">
<div className="col-auto">
<img src={`${var_api}/${service.service_image}`} alt="Room" style={{ borderRadius: "50%", height: "50px", width: "50px" }} />
</div>
<div className="col">
<span>{service.service_name} <span style={{float:"right",fontSize:"18px",color:"rgba(103, 120, 95)"}}><i class="bi bi-trash" style={{color:"red"}}  onClick={() => this.handleRemoveFromCart(service.id)}></i></span></span><br />
<span style={{color:"black",fontWeight:"bolder"}}>{service.service_price + service.additionalPrice} SGD</span>

</div>
</div>
<hr/>
<div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
<h6 style={{ fontSize: "13px" }}>
<b>Duration:</b> {service?.service_duration 
? this.convertMinutesToHours(service.service_duration + service.additionalDuration) 
: "0h 0m"}
</h6>

<h6 style={{ fontSize: "13px" }}>
<b>Beautician:</b> {service.employee_name}
</h6>

<h6 style={{ fontSize: "13px" }}>
<b>Sitting type:</b> {service.room_id ? "Room" : service.seat_id ? "Seat" : "-"}
</h6>

<h6 style={{ fontSize: "13px" }}>
<b>{service.room_id ? "Room" : service.seat_id ? "Seat" : " "} Name:</b> 
{service.room_id 
? (service.room_name ? service.room_name : "-") 
: (service.seat_name ? service.seat_name : "-")}
</h6>
</div>

<Form>
<div key="checkbox" className="d-flex align-items-center justify-content-between">
<div className="d-flex align-items-center">
<div

>
{/* <div
  style={{
    background: '#fff', // White background for the checkbox
    borderRadius: '4px',
  }}
> */}
  <Form.Check
    type="checkbox"
    id={`check-api-checkbox-additional-${index}`}
    checked={additionalChecked[index] || false}
    onChange={event => this.handleAdditionalCheckboxChange(event, index)}
    style={{
      margin: 0,
      borderRadius: '4px',
      outline: 'none',
      transition: 'all 0.3s ease', // Smooth transition on hover/focus
    }}
  />
{/* </div> */}
</div>{" "}
<Form.Check.Label
htmlFor={`check-api-checkbox-additional-${index}`}
style={{ fontSize: "13px", fontWeight: "bolder", marginLeft: "5px" }}
>
Additional
</Form.Check.Label>
</div>
<h6 style={{ float: "right", fontSize: "13px", fontWeight: "bolder" }}>
<i className="bi bi-clock"></i> {" "}
{this.formatTimeTo12Hours(service.from_time) || ""} - {this.formatTimeTo12Hours(service.to_time)}
</h6>
</div>
</Form>


            {additionalChecked[index] && (
              <div>
                <Form.Group controlId={`additional-cost-${index}`} className="mt-1">
                  <Form.Label style={{ fontSize: "12px", fontWeight:"bold" }}>Additional Cost</Form.Label>
                  <Form.Control type="number" placeholder="Enter additional cost" onChange={(event) => this.handleAdditionalCostChange(event, index)} value={service.additionalPrice}   min="0.1"
step="0.1"/>
                </Form.Group>
                <Form.Group controlId={`additional-duration-${index}`} className="mt-1">
                  <Form.Label style={{ fontSize: "12px", fontWeight:"bold" }}>Additional Duration (in mins)</Form.Label>
                  <Form.Control type="number" placeholder="Enter additional duration (minutes)" onChange={(event) => this.handleAdditionalDurationChange(event, index)} value={service.additionalDuration}   min="0.1"
step="0.1"/>
                </Form.Group>
              </div>
            )}


</div>
</div>
</Accordion.Header>
<Accordion.Body>
{/* Row for 'From Time' and 'To Time' */}
<div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '15px' }}>
{/* From Time */}
<div style={{ display: 'flex', alignItems: 'center' }}>
<label style={{ fontFamily: 'serif', fontWeight: 'bolder', marginRight: '10px' }}>
From Time
</label>
<input
type="time"
name="from_time"
placeholder="Select time"
value={service.from_time || ''}
onChange={(event) => this.handleTimeChange(event, index)}
/>
</div>

{/* To Time */}
<div style={{ display: 'flex', alignItems: 'center' }}>
<label style={{ fontFamily: 'serif', fontWeight: 'bolder', marginRight: '10px' }}>
To Time
</label>
<span>{this.formatTimeTo12Hours(service.to_time)}</span>
</div>
</div>

{/* Row for 'Beautician' */}
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
<label style={{ fontFamily: 'serif', fontWeight: 'bolder' }}>Beautician</label>
<Select
options={this.state.beauticians}
value={{ value: service.employee_id, label: service.employee_name }} 
onChange={(selectedOption) => this.handleBeauticianChange(selectedOption, index)}
placeholder="Select Beautician"
isSearchable={true}
menuPlacement="bottom"
styles={{
menu: (provided) => ({
  ...provided,
  zIndex: 9999,
}),
container: (provided) => ({
  ...provided,
  width: '100%',
}),
}}
/>
</div>
{validationError && <div style={{ color: 'red', fontWeight: 'bold' }}>{validationError}</div>}
</Accordion.Body>
</Accordion.Item>
</Accordion>

</div>


))
}



<br/>
{/* <div className="d-flex justify-content-center">
<Form>
<div key="checkbox" className="mb-3">
  <Form.Check type="checkbox" id="check-api-checkbox">
    <Form.Check.Input type="checkbox" isValid />
  </Form.Check>
</div>
</Form>

<Accordion>
<Accordion.Item eventKey="0" style={{border:"none"}}>
<Accordion.Header>
<div class="card" style={{ width: "21rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor:"rgba(103, 120, 95, 0.367)",borderRadius:"15px", margin:"8px" }} >
         
         <div class="card-body">
<div className="row align-items-center">
<div className="col-auto">
<img src={sign} alt="Room" style={{ borderRadius: "50%", height: "50px", width: "50px" }} />
</div>
<div className="col">
<span>Signature Hair Treatment<span style={{float:"right",fontSize:"18px",color:"rgba(103, 120, 95)"}}><i class="bi bi-trash" style={{color:"red"}}></i></span></span><br />
<span style={{color:"black",fontWeight:"bolder"}}>25 SGD</span>

</div>
</div>
<hr/>
<h6 style={{fontSize:"13px"}}><b>From-To Time:</b> 09:00 -10:00 <span  style={{fontSize:"13px", float:"right"}}><b>Beautician:</b> Jennie </span></h6>
<h6  style={{fontSize:"13px"}}><b>Sitting type:</b> {this.state.activeTab === "1" ? "room(room3)":"Seat(seat3)"} </h6>
</div>
</div>
</Accordion.Header>
<Accordion.Body>
<div style={{ display: 'flex', alignItems: 'center', gap:"10px", margin:"auto" }}>
<label style={{fontFamily:"serif",fontWeight:"bolder"}}>Select Beautician: </label>
<Select
options={[
    { value: 'Kalpana', label: 'Kalpana' },
    { value: 'Jenie', label: 'Jenie' },
    { value: 'Maria', label: 'Maria' },
    { value: 'Rani', label: 'Rani' },
    { value: 'Sheela', label: 'Sheela' }
]}
placeholder="Select Beautician"
onChange={this.handleOrderLabelSelectChange}
isSearchable={true}
menuPlacement="bottom"
styles={{ menu: (provided, state) => ({
    ...provided,
    zIndex: 9999, // Increase the z-index to ensure the dropdown is displayed above other elements
    maxWidth:"auto"
}) }}
/>

</div>
</Accordion.Body>
</Accordion.Item>
</Accordion>
</div> */}

<br/>
<div className="text-center">
<button className="btn btn-success" onClick={this.handleMovetoSeat}
style={{color:"white", backgroundColor:"rgba(103, 120, 95)",borderColor:"rgba(103, 120, 95)", marginRight:"5px"}} >Move to {this.state.activeTab === "1" ? "Seat" : "Room"}</button>
{
this.state.ExistingOrder ?  <button className="btn btn-success" style={{color:"white", backgroundColor:"rgba(103, 120, 95)",borderColor:"rgba(103, 120, 95)", fontWeight:"normal"}} onClick={this.handleAddSubmit} >Confirm Add Booking</button> :
<button className="btn btn-success" style={{color:"white", backgroundColor:"rgba(103, 120, 95)",borderColor:"rgba(103, 120, 95)", fontWeight:"normal"}} onClick={this.handleSubmit} >Confirm Booking</button>
}

<br/>
<br/>
</div>


</div>

</div>
<br/>

      {/* New Card for Time Slots */}
      <div
        className="col-12 col-md-6"
        style={{
          maxWidth: '35rem',
          margin: 'auto',
          border: '1px solid rgba(103, 120, 95)',
          padding: '10px',
          height: 'auto',
          borderRadius: '15px',
          marginTop: '-10px'
        }}
      >
        <div className="card-body">
          <h5 style={{ color: 'rgba(103, 120, 95)' }}>Available Time Slots - <strong>{this.state.activeTab === '1' ? 'Rooms' : 'Seats'}{' '}
          {this.state.selectedRoomName} {this.state.selectedSeatName}</strong></h5>
          <hr />
          <div className="time-slot-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
          <div className="calendar-body">
      {this.state.timeList.map((time, index) => (
        <div className="calendar-row" key={index}>
          <div className="calendar-time">
            <span className="calendar-time-text">{time}</span>
          </div>
          <div className="calendar-grid">
            {this.generateTimeSlots(time).map((timeSlot, offset) => (
              <div
                key={offset}
                className={`calendar-grid-cell ${
                  this.state.hoveredSlot === timeSlot ? 'hovered' : ''
                }`}
                onClick={() => this.handleSlotClick(timeSlot, index)}
                onMouseOver={() => this.hoverSlot(timeSlot)}
                onMouseLeave={this.leaveSlot}
              >
                {this.state.hoveredSlot === timeSlot && (
                  <span className="calendar-time-text">{timeSlot}</span>
                )}
                {this.state.selectedTime === timeSlot && (
                  <span className="selected-time-text">{timeSlot}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
            <div>
            {this.state.timeList.map((slot, index) => {
  const bookingStatus = this.isSlotBooked(slot);
  return (
    <div
      key={index}
      style={{
        padding: '8px 10px',
        backgroundColor: bookingStatus.booked ? 'rgba(103, 120, 95, 0.5)' : 'white',
        color: 'black',
      }}
      onClick={() => bookingStatus.booked && this.openModal(bookingStatus)}
    >
      {bookingStatus.booked && (
        <>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {`Order: ${bookingStatus.order_id} Customer: ${bookingStatus.customer_name}`}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '30px',
                height: '30px',
                border: '2px solid rgba(255, 255, 255, 0.7)',
                borderRadius: '50%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                marginLeft: '8px',
              }}
            >
              <i style={{ color: 'white', fontSize: '16px' }} className="bi bi-eye-fill"></i>
            </div>
          </div>
        </>
      )}
    </div>
  );
})}
            </div>
             {/* Modal to display booking details */}
        {/* Modal for booking details */}
<Modal
  show={this.state.isModalOpen}
  onHide={this.closeModal}
  backdrop="static"
  keyboard={false}
  size="md" // Set size to medium (or large as needed)
  style={{ borderRadius: '20px' }} // Add border radius style
>
  <Modal.Header closeButton>
    <Modal.Title>Booking Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
  <div>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <h6><strong>Customer Name:</strong> {this.state.selectedBooking?.customer_name}</h6>
  <h6><strong>Order ID:</strong> {this.state.selectedBooking?.order_id}</h6>
</div>
    <h6><strong>Services:</strong></h6>
    {this.state.selectedBooking?.services && this.state.selectedBooking.services.length > 0 ? (
      <ul style={{ listStyleType: 'none', padding: 0 }}>
      {this.state.selectedBooking.services.map((service, index) => (
        <li key={index} style={{
          display: 'flex',
          alignItems: 'center',
          border: '1px solid #ccc', // Add a border
          borderRadius: '5px',      // Rounded corners
          padding: '10px',          // Padding inside the list item
          margin: '10px 0',         // Margin between items
          backgroundColor: '#f9f9f9', // Light background color
        }}>
          <img
            src={`${var_api}/${service.service_image}`}
            alt={service.service_name}
            style={{ width: '50px', height: '50px', marginRight: '10px' }} // Spacing to the right of the image
          />
          <div style={{ flexGrow: 1 }}>
            <strong>{service.service_name}</strong> - Cost: ${service.service_cost} - Duration: {service.service_duration} mins
          </div>
          <div style={{ marginLeft: '10px', color: '#555' }}>
            <em>Employee: {service.employee_name}</em> {/* Include employee name */}
          </div>
        </li>
      ))}
    </ul>    
    ) : (
      <p>No services available for this booking.</p>
    )}
  </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={this.closeModal}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

          </div>
        </div>
      </div>
    </div>
  </Modal.Body>
</Modal>


      <Modal
        show={this.state.isPayModeEdit}
        onHide={this.handleCloseaPayModeEdit}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{padding:"12px",textAlign:"center"}}>
        <Modal.Title style={{fontSize:"19px", fontWeight:"bold",textAlign:"center"}}>Update Paymode</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
        <div className="p-3">
           
        {
  this.state.isPayModeEditLoading ? (
    <div className="text-center">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <Button variant="success"  onClick={this.handleUpdatePaymode} style={{float:"right"}}>
      <i className="bi bi-vector-pen"></i> Update
      </Button>
  )
}
<br/>
          <h6 style={{color:"blue", textAlign:"left"}}>Order No: <b>{editPaymodeOrder ? editPaymodeOrder.order_no: " "}</b></h6>
          <h6 style={{color:"rgba(103, 120, 95)"}}>Total Amount: <b>{editPaymodeOrder ? editPaymodeOrder.total : ""}</b> <span style={{float:"right"}}>Paymode Total: 
          <b style={{color: editPaymodeOrder && editPaymodeOrder.total == editModeTotal ? "rgba(103, 120, 95)" : "red"}}>{this.state.editSelectedAmounts ? this.state.editSelectedAmounts.reduce((sum, currentItem) => sum + currentItem.amount, 0) : ""}</b></span></h6>
          
          <div className="row">
            <div className="col">
            <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col" style={{textAlign:"center"}}>Paymode</th>
      <th scope="col" style={{textAlign:"center"}}>Amount</th>
    </tr>
  </thead>
  <tbody>
    {
     this.state.editSelectedAmounts && this.state.editSelectedAmounts
      .filter(mode => mode.pay_mode_name !== "CREDIT ORDER" && mode.pay_mode_name !== "GROUP LOCATION CREDIT ORDER")
      .map((mode,index)=>(
    <tr key={index}>
      <td>
        <div class={`card ${this.state.editSelectedAmounts[index].amount > 0 ? 'bg-success' : ''} ${this.state.editSelectedAmounts[index].amount > 0 ? 'text-light' : ''}`} style={{width:"auto", height:"auto", margin:"0px"}} onClick={() => this.handleEditCardClick(mode.id, editPaymodeOrder && editPaymodeOrder.total)}>
          <div class="card-body" style={{textAlign:"center"}}>
            {mode.pay_mode_name}
          </div>
        </div>
      </td>
      <td>
       <Input  type="number" id={`paymodeEditAmount${mode.id}`}  value={mode.amount} onChange={(e) => this.handleEditAmountChange(index, e.target.value)} style={{width:"140px",margin:"auto"}} min="0" />    
      </td>
    </tr>
      ))
    }
    </tbody>
        </table>
          
            </div>
            <div className="col">
            <label class="form-label text-success fw-bold m-0" style={{fontFamily:"serif"}}>Remark</label>
            <Input  type="text" id="editremark" placeholder="Remark" required  style={{width:"280px"}} value={this.state.updateRemark} onChange={this.handleRemarkChange} />    
            </div>
          </div>
        </div>
        <div style={{textAlign:"center"}}>
      
          {" "}
         <Button variant="danger"  onClick={this.handleCloseaPayModeEdit}>
            Close
          </Button>{' '} 
         
         </div>
        </Modal.Body>
      </Modal>
    </div>

   
    </>
    );
  }
}




export default withRouter(SbHOme);

